let lang = {
    atNow: 'Now',
    loginText1: 'Best Agency Service of the 2026',
   list:'list',
   customizationPackage:'Customization',
   regularPackage:'Regular Package',
   instantMessage:'Instant Message',
   transfer1:'Enterprise transfer to individual',
   transfer2:'transfer',
   transfer3:'Please enter the transfer traffic',
   transferSuccess: 'Transfer successful',
    loading:'loading...',
    searchText:'Search',
    proxyAccountPlaceholder:'Please enter an account name',
    priceText1:'Subtotal',
    expireTime:'Expiration date',
    productNewName:'Residential agent',
    loginLeftTitle2: 'A strong commitment to security and privacy',
    
  useCouponsMsg:'Please use the correct coupon',
  discountPrice:'Discounted price',
  springText:'Spring Carnival',
  huodongT1:"IPRocket Anniversary Celebration is Here!",
    huodongT2:"Traffic prices as low as $0.7/GB! ",
    huodongT3: "Event Period: November 22, 2024 - November 28, 2024 (UTC+0)",
    buynow:'Buy Products',
    Trial:"Trial",
    max_length: 'The maximum input length is',
    last_length: 'digits',
    max_num:'The maximum value cannot exceed',

    test:"test",
  home: 'Home',
  product: 'Products',
  price: 'Price',
  priceNew: 'Pricing',
  demo: 'Use cases',
  resources: 'Resources',
  panel1Title1: 'High-quality residential proxy, fast and stable！',
  panel1tip1: 'More than 60M ethical IPs',
  panel1tip12: 'More than 90M ethical IPs',
  panel1tip2: 'Support HTTP(s) and Socks5',
  panel1tip3: 'Success rate over 99.05%',
  panel1tip32: 'Success rate over 99.86%',
  panel1tip4: 'City and state positioning',
  panel1tip5: 'No concurrent sessions or bandwidth limitations',
  panel1tip6: '24/7 Technical Support',
  login_detailedAddress:'Detailed Address',
  login_phonenumber:'Phone Number',
  login_companyName:'Company Name',
  login_companyAddress:'Company Address',
    login_email: 'Email',
    login_noaccount: "Don't have an account?",
    emailName:'Email',
  login_password: 'Password',
  login_password_submit: 'Verify Password',
  login_verifyCode: 'Verification Code',
    login_now: 'Login Now',
  have_account:'Already have an account?',
  login_password_find: 'Forgot password?',
  login_register_now: 'Register Now',
  login_title: 'Login',
  reset_password_title: 'Reset password',
  or: 'Or',
  login_google: 'Use Google login',
  login_tip3: 'I have read and agree',
  and: ' And ',
  check: 'Check',
  register_account: 'Register an account',
  new_password: 'Enter new password',
  new_password_submit: 'Confirm new password',
  login_tip1: 'Enter your account email address and we will send you an email',
  login_tip2: 'Verification code to your email',
  send: 'Send',
  logon_return: 'Return to login',
  continue: 'Continue',
  login_title1: 'Global Proxy',
  login_title2: 'Easy access to public data',
  login_title3: 'Flexible pricing',
  login_title4: 'Rotation and viscosity conference',
  login_title5: '99.86% success rate',
  login_title6: 'support the team 24/7',
  login_title7: 'Unlimited concurrent sessions',
  login_title8: 'Please check the terms of service and privacy agreement',
  login_title9: 'Please enter complete login information',
  login_again: 'Modified successfully, please log in again',
  success: 'Success',
  input_password_again: 'Please enter your password again',
  input_password: 'The password must be 8-20 characters long and include both letters, numbers, and special characters.',
  input_password_6: 'The password must be 6-20 characters long and include both letters, numbers, and special characters.',
    password_diff: 'The password entered twice is inconsistent',
  input_email: 'Please enter your email address',
  
  input_verifyCode: 'Please enter the verification code',
    login_error: 'Login failed',
    validateLength:'Maximum length of 256 characters!',
  generateQRCode:'Generate QRCode',
    copy: 'Copy',
    loginTEXT1: 'Invitation code',
    loginTEXT2: 'Confirm your email',
    loginTEXT3:'Verification code has been sent to your',
    loginTEXT4:'Enter the code below',
    loginTEXT5:'You can resend the code after',
    loginTEXT6: 'seconds',
    loginTEXT7: 'Please check your spam folder or contact us through the following means.',
    loginTEXT8: "Haven't received the email",
    loginTEXT9: 'Confirm email',
    loginTEXT10:'Next',
    loginTEXT11:'Send verification code',
    loginTEXT12:'Re-enter your password',
    loginTEXT13: 'Reset password',
    loginTEXT14: 'CAPTCHA',
    loginTEXT15:'Verify',
    loginTEXT16: 'Resend',
    loginTEXT17: '',
    // 注册
    registTitle1: 'Registration Successful!',
    registerword1: 'Contact our sales team now to claim your',
    registerword2: '1GB Free Data Traffic',
    loginLeftTitle:'Welcome to the web data platform trusted by more than 4,000 companies',
    loginLeftText1: '24/7 customer support available',
    loginLeftText2: 'Locate any country (region), continent, and city',
    loginLeftText3: '99.86% average request success rate',
    loginLeftText4: 'Ethically sourced proxies',
    loginLeftText5: 'Over 90 million real IPs',
    loginLeftText6:'Welcome to join Mic.',
    loginLeftText7:'Access over 60 million real residential IPs and embark on your global journey of data collection.One stop connection to 195+countries and regions,stable,compliant,and enterprise level security.',

    // 登录页面新增翻译
    welcome_back: 'Welcome back',
    welcome_register: 'Welcome to register',
    start_journey: 'Start your global proxy journey',
    description: 'Global 210+ countries and regions, 60 million real residential IPs, 99.7% online rate. Enterprise-level data collection and multi-account operations start here.',
    feature1: 'Enterprise SOC 2 + GDPR compliance audit',
    feature2: 'Millisecond response · 99.7% annual uptime',
    feature3: '7×24 Chinese expert technical support',

    // 仪表盘
  dashboard1: 'Total traffic',
  dashboard2: '',
  dashboard3: 'Remaining ',
  dashboard3_1: 'traffic',
  dashboard4: 'Current balance',
  dashboard5: 'Add Balance',
  dashboard6: 'Total Cost',
  dashboard7: 'Please enter the CDK',
  dashboard8: 'Exchange',
  dashboard9: 'Generate CDK',
    dashboard10: 'A multiple of 10',
    dashboard10_2: 'A multiple of 2 or 10',
  dashboard11: 'Traffic Usage Statistics',
  dashboard12: 'Help Center',
  dashboard13: 'Contact us',
  dashboard14: 'FAQ',
  dashboard15: 'You can learn how to use a proxy in the article',
  dashboard16: 'Quick Guide',
  dashboard17: 'Some functions and usage processes that you can learn about through the user',
  dashboard18: 'Tool integration',
  dashboard19: 'You can collaborate in tool integration to improve work efficiency',
  dashboard20: 'Traffic Usage',
  dashboard21: 'Remaining Reminder',
  dashboard22: 'When the GB amount or days for an individual plan fall below your selection, a reminder will be sent.',
  dashboard23: 'When the GB amount or days for a business plan fall below your selection, a reminder will be sent.',
  dashboard23_all:'When the remaining data or days for an individual/enterprise plan fall below your selected threshold, a reminder will be sent to the top right corner of the personal center.',
    dashboard24: 'Remaining Days',
    dashboard25: 'Flow Rate',
    dashboard26: 'Redemption Code',
    dashboard27: 'Wallet Balance',
    dashboard28: 'You must fill in one of the personal/enterprise plans, and it must be greater than 0, to enable reminders.',
    dashboard29: 'Individual plan reminder',
    dashboard30: 'Business plan reminder',
    dashboard31: 'Notification reminder',
    dashboard32: 'Mark as Read',
    dashboard33: 'Open',
    dashboard34: 'Close',
    dashboard35: 'Read',
    dashboard36: 'Unread',
    dashboard37: 'Close',
    dashboard38: 'No news for now.',
    dashboard39: 'Personal Plan Usage Record',
    dashboard40: 'Personal Plan Activation Record',
    dashboard41: 'View All',
    dashboard43: 'Save',
    dashboard44: 'Account recharge',
    dashboard45: 'Minimum recharge',
    dashboard46: 'Real-time arrival',
    dashboard47: '1: 1. Proportional transfer',
    dashboard48: 'multiple of',
    
    successful: 'successful',
    Modification:'Modification',
    // 仪表盘
  // 产品管理-价格
  price1: 'Plan',
  price2: 'Gain insight into a pool of 60 million + ethically sourced residential IPs from more than 210 regions around the world.',
  price3: 'Please enter a new password again',
  price4: 'Tips',
  price5: 'Assignable traffic: Enterprise plan traffic can generate redemption codes (CDK), which users can redeem into personal plan traffic for use.',
  price6: '180-Day Validity: The validity period of enterprise plan traffic for users is 180 days, the validity of the generated CDK is 180 days, and the validity of the personal plan traffic after redemption is 180 days.',
  price7: 'Personal Plan',
  price8: 'Enterprise Plan',
  price9: 'Please enter old password',
  price10: 'Please enter new password',
    price11: 'Please confirm the new password',
    price12: 'The maximum length for the password is 20 characters.',
    price13:'The minimum length for the password is 8 characters.',
    price14: 'Please enter the password',
    price15: 'Usage Instructions',
    price16: 'Plan traffic can be converted to redemption codes (CDK) for users to redeem and use.',
    price17: 'Enterprise plan traffic',
    price18: 'CDK redemption code',
    price19: 'Post-redemption individual package:',
    price20: '180 days',
    price21: 'Enterprise Plan',
    price22: 'Purchase enterprise traffic package',
    price23: 'Generate CDK',
    price24: 'Convert enterprise plan traffic to CDK',
    price25: 'User Redemption',
    price26: 'Users redeem traffic using CDK',
    price27: 'Traffic Processing',
    price28: 'Users obtain personal usable traffic',
    price29: 'Note: Each stage independently calculates a validity period of 180 days',
    price30: 'Enterprise Traffic',
    price38: 'Leading Advantage',
  // 产品管理-价格
  // 产品管理-获取IP
  reset: 'Reset',
  pleaseInput: 'Please Input',
  pleaseSelect: 'Please Select',
  country: 'Country',
  city: 'City',
  format: 'Format',
  count: 'Count',
  generate1: 'Generate',
  operator: 'ISP',
  ip1: 'Search Type',
  ip2: 'Select State (Province) - City',
  ip3: 'State/Region',
  ip4: 'Session Type',
  ip5: 'Rotational proxy changes IP address every time a request is made,',
  ip5_1:'Sticky mode can keep the same IP address for a certain period of time.',
    ip6: 'Minutes',
  ip7: 'Proxy Host',
  ip8: 'Proxy Port',
  ip9: 'Proxy Account',
  ip10: 'Proxy Password',
  ip11: 'Please Enter a password consisting of 8-15 digits and letters',
  ip11_short:'Please enter a password with 8-15 characters.',
  ip11_must:'Must include uppercase letters, lowercase letters, numbers, and special characters(@$!%*#?&.)',
    ip12: 'Basic Curl Example',
  ip13: 'Authenticated',
  ip14: 'API Access',
  ip15: 'Non account authentication',
  ip16: 'Proxy Type',
  ip17: 'Response Format',
  ip18: 'Separater',
  ip19: 'Enter and wrap',
  ip20: 'Line Break',
  ip21: 'Enter',
  ip22: 'Custom Characters',
  ip23: 'Copy Link',
  ip24: 'Open Link',
  ip25: 'IP Type',
  ip26: 'Conversation Type',
  
  ip27: 'Quantities',
    ip28: 'Please enter',
    ip29: 'Frequently Used Countries',
    ip30: 'Proxy Format',
    ip31: 'Proxy List',
    ip32: 'Link Format',
    ip33: 'Link List',
    ip34:'Generation Rules',
    ip35:'rotation',
    ip36:'stickiness',
    ip37:'session time',
  // 产品管理-获取IP

    // 产品管理-代理账户
    code_tip:'Click to generate QR code. Only the first piece of data will generate a QR code if there are multiple pieces of data.',
  add: 'Add',
  enable: 'Enable',
  disable: 'Disable',
  delete: 'Delete',
  operate: 'Operate',
  edit: 'Edit',
  noData: 'No Data',
  remark: 'Remark',
  cancel: 'Cancel',
  confirm: 'Confirm',
  tip: 'Tip',
  state: 'State',
  status: 'Status',
    noEmpty: 'Cannot be empty',
    length5:'The maximum length is 5 digits.',
  positiveInteger: 'It can only be a positive integer',
  accountList: 'Account List',
  proxyAccount1: 'Add Proxy Acount',
  proxyAccount2: 'Account name',
  trafficTotalBandwidth: 'Total Bandwidth',
  trafficDownloadBandwidth: 'Download Bandwidth',
  trafficUploadBandwidth: 'Upload Bandwidth',
  trafficConnections: 'Connections',
  trafficConnectionsUnit: 'connections',
  trafficDataUpdatedAt: 'Data updated at',
  trafficNoDataHint: 'Traffic data will update automatically after the proxy is used.',
  proxyAccount3: 'Add Time',
  proxyAccount4: 'Approval Status',
  proxyAccount5: 'Account',
  proxyAccount6: 'Please enter the account name',
  proxyAccount7: 'Traffic Limit',
  proxyAccount8: 'Please enter a number',
  proxyAccount9: 'please enter a remark',
  proxyAccount11: 'Are you sure you want to delete this proxy account',
  proxyAccount12: 'Please enter IP address',
  proxyAccount13: 'unlimited',
  passwordLength: 'The password contains 6 to 32 characters',
  passwordLength_15:'6-15 characters,cannot contain spaces.',
    // 产品管理-代理账户
  error_100000:'The maximum value cannot exceed 50,000.',
  num_required:'The minimum quantity is 1.',

    // 产品管理-白名单
  whitelist1: 'Add Allowlist',
  whitelist2: 'Current IP',
  whitelist3: 'Allowlist IP',
  whitelist4: 'Please enter IP',
  whitelist5: 'Are you sure you want to delete this IP address',
  whitelist6: 'Extract whitelist links',
  whitelist7: 'No whitelisted IPs have been added yet, unable to generate',
  // 产品管理-白名单

  // 产品管理-计划
  type: 'Type',
  traffic: 'Traffic',
  produce: 'Produce',
  generate: 'Generate',
  startTime: 'StartTime',
  endTime: 'EndTime',
  wrongTime:'The start time cannot be greater than the end time.',
  missingTime:'Please select the complete time',
  effectiveDate: 'Effective Date',
  expireDate: 'ExpireDate',
  search: 'Search',
  remainder: 'Remaining Traffic',
  step1: 'Step1',
  step2: 'Step2',
  notUsed: 'Not Used',
  used: 'Used',
  invalid: 'Invalid',
  complete: 'completed',
  cdktype: 'CDKey exchange',
  cdktype2: 'Enterprise traffic transfer',
  qrtx: 'Are you sure you want to submit?',
  qrbt: 'Confirm submission',
  plan1: 'Enter CDKey',
  plan2: 'Total Traffic',
  plan3: 'Remaining Validity (Day)',
  plan4: 'Traffic Usage Enquiry',
  plan5: 'Main Account',
  plan6: 'Sub Account',
  plan7: 'Dynamic Traffic',
    plan8: 'Remaining Traffic',
  plan8_short:'Used Traffic',
  plan9: 'Sales Volume',
  plan10: `As shown in Figure 1, enter the amount of traffic you want to generate (10 or multiples of 10) in the indicated area, then click the "Generate CDK" button on the right. (The CDK is valid for 180 days.)`,
  plan11: `As shown in Figure 2, enter the CDK you generated in the indicated area, then click the "Exchange" button on the right. Once the personal plan traffic is successfully redeemed, it will be ready for use.`,
  plan12: 'Operation log',
  plan13: 'Account Name',
    plan14: 'How do I generate and use a CDKey?',
    plan14_text:'The validity period of the enterprise plan traffic is 180 days. When there is remaining traffic in the current enterprise plan, any additional enterprise plan traffic obtained will be merged with the remaining traffic, and the validity period will be extended by another 30 days.',
  plan15: 'Operating time',
  plan16: 'activated',
  plan17: 'Inactive',
  plan18: 'Personal Plan Usage Guide',
  plan19: 'How To Obtain',
  plan20:
    'Users can purchase personal plan traffic packages directly on the official website or use a CDK to redeem personal plan traffic.',
    plan20_1: 'Users can purchase personal plan traffic packages directly on the official website or use a CDK to redeem personal plan traffic.',

    plan21: 'Activation Conditions',
  plan22:
    'The personal plan traffic takes effect immediately after being obtained. Users using the personal plan traffic for the first time may need to wait 1 to 3 minutes.',
    plan22_1: 'The personal plan traffic takes effect immediately after being obtained. Users using the personal plan traffic for the first time may need to wait 1 to 3 minutes.',
    plan23: 'Renewal Mechanism',
    plan23_1: 'Waiting List Mechanism',
  plan24:
    'When there is remaining traffic in the current personal plan, any additional personal plan traffic obtained by the user will be merged with the remaining traffic, and the validity period will be extended by another 60 days.',
    plan24_1: 'When there is currently active personal plan traffic, any newly purchased personal plan traffic or personal plan traffic obtained through a CDK will be queued as inactive plans. After the current personal plan traffic is used up or expires, the new traffic will take effect automatically in the order it was queued.',
    plan25: 'Validity Period',
  plan26:
    'The validity period of each newly purchased personal plan traffic or personal plan traffic obtained through a CDK is 60 days, starting from the time of the last purchase or redemption.',
    plan26_1: 'The validity period of each newly purchased personal plan traffic or personal plan traffic obtained through a CDK is 60 days, and the activation time of the personal plan traffic will be the start time.',
    plan27: 'Type',
  planall: 'all',
  planused: 'used',
  planunused: 'unused',
  planexpired: 'expired',
  plancomplete: 'complete',
  plandiversion: 'Flow diversion',
  planczdx: 'operand',
  planczll: 'Operating flow',
  planhzdx: 'Transfer object',
  planmasg: "The transfer object and the operation object cannot be the same person",
  pleaseData: "Please select a date",
  plan28: 'Expired',
    plan29: 'Invalidated',
    plan29_1: 'Invalid and pending review',
    plan30: 'Commission Exchange',
    plan31: 'Purchased by Enterprise',
    plan32: 'CDK Exchange',
    plan32_2:'CDK generation',
    plan33: 'Enterprise Expired',
    plan34: 'System Return',
    plan35: 'System Addition',
    plan36: 'Purchase Individual',
    plan37: 'Wallet Renewal',
    plan38: 'Individual Expired',
    plan39: 'Users',
    plan40: 'CDK/Order ID',
    plan41: 'One-Click Export',
    plan42: 'Post-change balance($)',
  plan43: 'Post-change flow(GB)',
  plan44:'Personal plan has been completed',
  plan50: 'User',
  // 产品管理-计划

  // 账户管理-个人信息
  loginYour: 'Login Your',
  creatYour: 'Creat Your',
  resetYour: 'Reset Your',
  account: 'Account',
  email: 'Email',
  verified: 'VERIFIED',
  save: 'Save',
  profile1: 'Personal Info',
  profile2: 'Account Information',
  profile3: 'Registration Time',
  profile4: 'Modify Password',
  profile5: 'Old Password',
  profile6: 'New Password',
  profile7: 'Reconfirm',
    profile8: 'Modify Success',
    profile9: 'First Name',
    profile10: 'Last Name',
    profile11: 'Country of Residence',
    profile12: 'Province (State)',
  accountInfo: 'Account Information',
  features: 'Product Overview',
  features_desc: 'Your account activity',
  balance_desc: 'Available balance',
  joinDays_desc: 'Days since joining',
  verified_desc: 'Identity verified',
  password_change_tip: 'Enter your current password and new password',
  // 账户管理-个人信息

  // 账户管理-购买记录
  billing1: 'Purchase Record',
  billing2: 'CDKey Exchange Record',
  billing3: 'Please enter the order number',
  billing4: 'Order Number',
  billing5: 'Payment Amount',
  billing6: 'Payment Method',
  billing7: 'Payment Time',
  billing8: 'Validity Period',
  billing9: 'Order Status',
  billing10: 'Please enter the CDK',
  billing11: 'Exchange Traffic',
  billing12: 'Exchange Time',
  // 账户管理-购买记录

  // 账户管理-推广分佣
  serialNumber: 'Number',
  createTime: 'Create Time',
  referralProgram1: 'Refer new customers and get rewarded!',
  referralProgram2: 'Your referral link',
  referralProgram3: 'Copy the URL',
  referralProgram4: 'Use it to share and recommend IPRocket',
  referralProgram5: 'Get commission on each referral order',
  referralProgram6: 'Total Revenue',
  referralProgram7: 'Withdraw Money',
  referralProgram8: 'Exchange Traffic',
  referralProgram9: 'Invitation transaction records',
  referralProgram10: 'Withdrawal Records',
  referralProgram11: 'Exchange records',
  referralProgram12: 'User Account',
  referralProgram13: 'Transaction Order',
  referralProgram14: 'Transaction Amount',
  referralProgram15: 'Rebate Ratio',
  referralProgram16: 'Rebate Amount',
    referralProgram17: 'Spent Balance',
  referralProgram17_1: 'Withdrawal Amount',
  referralProgram18: 'Withdrawal Method',
  referralProgram19: 'Withdrawal Account',
  referralProgram20: 'Withdrawal Time',
  referralProgram21: 'Withdrawal Status',
  referralProgram22: 'Audit Status',
  referralProgram23: 'Audit Result',
  referralProgram24: 'Exchange Amount',
  referralProgram25: 'Exchange Traffic',
  referralProgram26: 'Exchange Time',
  referralProgram27: 'Alliance Banner',
  referralProgram28: 'Banner Example',
  referralProgram29: 'Banner code language',
  referralProgram30: 'Banner size (pixels)',
  referralProgram31:
    'The withdrawal amount must be greater than $100 and can only be an integer, with a 2% handling fee deducted for each transaction.',
  referralProgram32:
    'When using balance to redeem traffic, the amount of traffic entered must be greater than 10GB and must be an integer. Residential proxy $0.8=1GB, Premium residential proxy $1=1GB',
  referralProgram33: 'Cryptocurrency(USDT)',
  referralProgram34: 'Wallet address',
  referralProgram35: 'Wallet address confirmation',
  referralProgram36: 'The wallet addresses are inconsistent twice',
  referralProgram37: 'Balance is insufficient',
  referralProgram38: 'Invitation records',
  referralProgram39: 'Trading volume',
    referralProgram40: 'My commission',
    referralProgram41: 'Please select a year',
    referralProgram42: 'Please select a month',
    referralProgram43: 'Search',
    referralProgram44: 'Invite friends to join IPRocket and earn generous USD rewards!',
    referralProgram45: 'For each successful referral who makes a purchase, you will receive up to 10% cash reward -- with no limit on the reward amount, the more you promote, the more you earn!',
    referralProgram46: 'Copy your exclusive referral link now and start sharing to earn unlimited cash earnings!',
    referralProgram47: 'Share your referral link or invitation code, and recommend users to use the product to get rewards',
    referralProgram48: 'Default Link/Invitation Code',
    referralProgram49: 'Clicks',
    referralProgram50: 'share to',
    referralProgram51: 'Data Summary',
    referralProgram52: 'Refresh',
    referralProgram53: 'Cycle',
    referralProgram54: 'All',
    referralProgram55: 'Reward Rules',
    referralProgram56: 'Earn these rewards by recommending the product to users',
    referralProgram57: 'For each successful referral who makes a purchase, you will receive up to 10% cash reward!',
    referralProgram58: 'Preview',
    referralProgram59: 'Download',
    referralProgram60: 'Upload',
    referralProgram61: 'IPRocket Global Premium Proxy!',
    referralProgram62: 'Experience lightning speeds through our vast network of 90M+ ethical proxies, offering 99.86% uptime for seamless project execution',
    referralProgram63: 'Withdrawal',
    referralProgram64: 'Overview',
    referralProgram65: 'Link',
    referralProgram66: 'Report',
    referralProgram67: 'Withdrawal Request',
    referralProgram68: 'Cash',
    referralProgram69: 'Withdrawal Application',
    referralProgram70: 'Minimum $100',
    referralProgram71: '2% Fee',
    referralProgram72: 'Confirm TRC20 Wallet Address',
    referralProgram73: 'Funds are expected to arrive within 7 business days after submitting the withdrawal request',
    referralProgram74: 'The withdrawal amount will be calculated based on the exchange rate on the day of processing, please confirm the information is correct to avoid withdrawal failure',
    referralProgram75: 'Recharge Traffic',
    referralProgram76: 'Recharge Account',
    referralProgram77: 'Account',
    referralProgram78: 'Minimum 10G',
    referralProgram79: 'Time',
    referralProgram79_1: 'Expiry date',
    referralProgram80: 'Invited Users',
    referralProgram81: 'Trend Chart',
    referralProgram82: 'Link Dashboard',
    referralProgram83: 'Registrations',
    referralProgram84: 'Processing Withdrawal',
    referralProgram85: 'Rewards Paid',
    referralProgram86: 'Please select a status',
    referralProgram87: 'Please enter the invited user',
    referralProgram88: 'Day',
    referralProgram89: 'Month',
    referralProgram90: 'Withdrawing',
    referralProgram91: 'Withdrawal completed',
    referralProgram92: 'Withdrawal failed',
    referralProgram93: 'Please select a withdrawal method',
    referralProgram94: 'Please select a withdrawal status',
    referralProgram95: 'Proxy traffic',
    referralProgram96: 'Please enter the withdrawal amount',
    referralProgram97: 'The minimum withdrawal amount is $100',
    referralProgram98: 'Incorrect input type',
    referralProgram99: 'Please enter the recharge data volume',
    referralProgram100: 'The minimum recharge data volume is 10GB',
    referralProgram101: 'Please enter the wallet address again',
    referralProgram102: 'The wallet addresses entered do not match',
    referralProgram103: 'Please enter the wallet address',
    referralProgram104: 'Please select the withdrawal application',
    referralProgram105:'Number Of Transactions',
    referralProgram106:'Already received',
    // 账户管理-推广分佣

    // Rocket钱包
    Paymentsuccessful: 'Payment successful',
    PaddlePay:'Paddle Payment',
  rechange: 'Deposit',
  plan: 'Plan',
  discount: 'Discount',
  rocket1: 'Deposit Record',
  rocket2: 'Order Number',
  rocket3: 'Amount',
  rocket4: 'Payment Method',
  rocket5: 'Purchase Time',
  rocket6: 'Purchase Status',
  rocket7: 'Receipt',
  rocket8: 'Costs Records',
  rocket10: 'Deposit to Your Account',
  rocket11: 'Benefits of deposit for your account',
  rocket12:
    'Deposit through top-ups offers several advantages for regular users, including the complete elimination of wallet and network confirmation hassles for future purchases.',
  rocket13: 'Balance',
  rocket14: 'Total Deposit Amount',
  rocket15: 'Usage Amount',
  rocket16: 'Auto-renewal',
  rocket17: 'Residential Proxy',
  rocket18: 'Price Per GB',
  rocket19p: 'The minimum reminder data usage is 1GB.',
  rocket19l: 'GB,(The wallet will increase your traffic in time before it expires).',
  rocket20p: 'The minimum reminder period is 1 day.',
  rocket20l: ' days,(The wallet will automatically renew the subscription before it expires).',
  rocket21: 'Reset',
  rocket22: 'Please choose a package',
  rocket23: 'Subscription Price',
  rocket24: 'Budget Control',
  rocket25: 'Cost Savings',
  rocket26: 'Convenience',
  rocket27: 'Time Saving',
  rocket28: 'Ongoing Access',
  rocket29: 'Reduce Costs',
  rocket29: 'Total Price',
  rocket30: 'Continue to Payment',
  rocket31: 'Please scan the QR code below to complete the payment',
  rocket32: 'The QR code will expire after {}, please make the payment as soon as possible',
  rocket33: 'Payment Completed',
  rocket34: 'Cancel Payment',
  rocket35: 'Order Summary',
  rocket36: 'Price per GB',
  rocket37: 'TOTAL',
  rocket38: 'Do you want to use coupons?',
  rocket39: 'Enter discount code',
  rocket40: 'Balance Recharge',
  rocket41: 'This order has not been paid yet',
  rocket42: 'Generate crientSecret',
  rocket43: 'An error occurred during the payment confirmation process',
  rocket44: 'Order Number',
  rocket45: 'Order Payment',
  rocket46: 'Subscription Price Per GB',
    rocket47: 'Coupon retrieval failed',
    rocket: 'Rocket wallet',
    back:'Back',
    // Rocket钱包
    addProxyAccounts: 'newly added',
  // 导航顶部
  balance: 'Balance',
  navbar2: 'Enterprise traffic expires in {} days',
  navbar3: 'Personal plan traffic expires in {} days',
  navbar4: 'Log Out',
  // 导航顶部

  panel2Title1: 'Global proxy pool with easy access to public data',
  panel2TItle2En: 'IPRocket residential proxy pools are procured from partners who adhere to strict business ethics',
  world: 'Countries and regions',
  panel2text1: 'Ensuring full global coverage and accessibility',
  globalIP: 'Global IP',
  increase: 'This number is still growing',
  customer: 'Customers',
  reliability: 'Strong track record of reliability and customer satisfaction',
  ISP: 'ISP Partners',
  network: 'Provides extensive network coverage and reliable connectivity',

  panel3Title: 'All-in-one dashboard: simple, clear and efficient',
  panel3text:
    'Configure your proxy, track data, automate order fulfillment and perform many more actions with our dashboards that can be adapted to your needs!',
  panel3btn: 'Register Now',

  panel4Title: 'Fits your various use case requirements',
  panel4text1: 'Market Research',
  panel4text2: 'Travel Fare aggregation',
  panel4text3: 'Selling and E-commerce',
    seo: 'SEO and SERP',
    seo_1: 'SEO and SERP',
  adProven: 'Ad Verificatgion',
  twitch: 'Twitch',
  facebook: 'Facebook',
  discord: 'Discord',
  instagram: 'Instagram',
  pinterest: 'Pinterest',
  amazon: 'Amazon',
  eBay: 'eBay',
  shopify: 'Shopify',
  etsy: 'Etsy',
  airbnb: 'Airbnb',
  chatGPT: 'ChatGPT',
  youtube: 'Youtube',
  tiktok: 'Tiktok',
  reddit: 'Reddit',
  walmart: 'Walmart',
  vinted: 'Vinted',
  mercari: 'Mercari',
  airbhb: 'Airbnb',
  panel4text16: 'All Use Cases →',

  panel5Title: 'Popular Residential Proxy Locations',
  america: 'United State',
  france: 'France',
  england: 'United Kindom',
  HongKong: 'Hong Kong',
  germany: 'Germany',
  vietnam: 'Vietnam',
  japan: 'Japan',
  canada: 'Canada',
  brazil: 'Brazil',
  Philippines: 'PhilIPpine',
  australia: 'Australia',
  panel5text11: 'View All',

  panel6Title: 'Choose your plan',
  panel6text1: 'Support HTTP(s) and Socks5 proxy server ',
  panel6text2: 'Personal Plan',
    panel6text3: 'Enterprise Plan',
    panel6text4:'Personal Traffic Details',
    promotionalPrice: 'Price',
    originalPrice:'Original Price',
  starter: 'Starter',
  requisite: 'Essential',
  template: 'Standard',
  add: 'Plus',
  high: 'Premium',
  day: 'Days',
  allSession: 'Unlimited sessions',
  SuccessRate: 'success rate',
  buy: 'Buy Now',
  allocation: 'Distributable traffic',
  countryAndCity: 'Country and city targeting',
  session: 'Rotating and sticky sessions',
  allWeather: '24/7 support',

  panel7Title: 'Latest Reviews Customer Feedback',

  panel8Title: 'Q & A',
  EmailSupport: 'E-mail support',
  footerTitle: 'Expand your business with IPRocket！',
  footerBtnRight: 'Contact Sales',
  footerText1: 'Follow us',
  footerText2: 'Stay connected',
  address: 'Locations',
  company: 'Company',
  allAddress: 'All Locations',
  house: 'Residential Proxy',
  houseText: 'Over 60 million real IPs, supporting HTTP(s) and Socks5.',
  housePrice: 'Residential Proxy',
  housePrice2: 'Premium residential proxy',
  blog: 'Blogs',
  integrate: 'API Guide',
  quickStartGuide: 'Quick Start Guide',
  helpIntroWelcome: 'Welcome to',
  helpIntroDocs: 'Documentation',
  helpIntroDescription: 'All guides for using Mic, from account registration to advanced configuration.',
  helpIntroGuideUnit: 'guide',
  helpIntroStepUnit: 'steps',
  helpIntroFeatureUnit: 'features',
  helpIntroDocument: 'DOCUMENT',
  helpIntroGuidedSteps: 'GUIDED STEPS',
  helpIntroFeatures: 'FEATURES',
  helpIntroQuickJump: 'QUICK JUMP',
  helpIntroGettingStarted: 'Getting Started',
  helpIntroGuideTag: 'Guide',
  helpIntroSubtitle: 'Master the core features of the Mic proxy service from scratch',
  helpIntroAudienceLabel: 'AUDIENCE',
  helpIntroAllUsers: 'All users',
  helpIntroAudienceDescription: ', whether you are an individual developer or enterprise user',
  helpIntroCoreFeatures: 'Core Features',
  helpIntroFastProxy: 'High-Speed Proxy',
  helpIntroFlexibleBilling: 'Flexible Billing',
  helpIntroDashboard: 'Easy Dashboard',
  helpIntroSupport: 'Technical Support',
  helpIntroAvailability: 'High Availability',
  helpIntroManager: 'Dedicated Manager',
  helpIntroSolutions: 'Custom Solutions',
  helpIntroApiAccess: 'API Access',
  helpIntroReports: 'Usage Reports',
  helpIntroStepsTitle: 'Getting Started',
  helpIntroRegister: 'Register Account',
  helpIntroStartTag: 'START',
  helpIntroRegisterDescription: 'Create your account on our website',
  helpIntroChoosePackage: 'Choose Package',
  helpIntroChoosePackageDescription: 'Select the package that suits your needs',
  helpIntroConfigureProxy: 'Configure Proxy',
  helpIntroConfigureProxyDescription: 'Configure your proxy settings',
  helpIntroStartUsing: 'Start Using',
  helpIntroDoneTag: 'DONE',
  helpIntroStartUsingDescription: 'Start using the proxy service',
  quickStart: 'Quick Start Guide',
  helpCenter: 'Help Centre',
  questions: 'Q & A',
  partner: 'Partners',
  aboutUs: 'About us',
  contactUs: 'Contact us',
  nowBuy: 'Buy Now',
  plan: 'Referral Program',
  terms: 'Shipping Terms',
  Policy: 'Refund policy',
  copyright: '© Copyright 2024 IPRocket Ltd. | All Rights Reserved',
  privacy: 'Privacy Policy',
  service: 'Service Terms',

  priceText: 'As low as ',
  priceDoller: ' $0.9 per GB  ',
  priceDoller2: ' $0.7 per GB',
  shoesAndTickets: 'Sneaker and Ticket Bots',
  dataCapture: 'Data Collection',
  emailProtection: 'E-mail Protection',
  mediaMarketing: 'Social Media Marketing',
  industry: 'Use cases',
  socialMedia: 'Social Media',
  onlineRetailers: 'E-commerce',
  login: 'Login',
  register: 'register',
  registerSuccess: 'Registration Successful!',
  email: 'Mic.io@gmail.com',
  watchPrice: 'Price Monitoring',
  whyareyouIPScoket: "Why should you use IPRocket's residential proxy?",
  IPStitle1: 'Ultra-large residential IP proxy pool',
  IPScontent1: 'Ethically acquire A+ level model proxies from the very large 60M+ IP pool on the market.',
  IPStitle2: 'Reliable Networks',
  IPScontent2: 'The most reliable infrastructure with 99.05% uptime, backed by patented solutions.',
  IPStitle3: 'Fastest response time',
  IPScontent3: 'Market-leading 0.3 second response time for uninterrupted data collection.',
  IPStitle4: 'Specialized residential proxies',
  IPScontent4: 'No sharing, no splicing - your private proxy is only available when you use it',
  IPStitle5: 'Instant IP Change',
  IPScontent5:
    'Simply click/tap or request via API to get the new IP via the dashboard. instantly change your residential proxy with the new proxy in the pool.',
  IPStitle6: 'Accessibility',
  IPScontent6: 'You can use a proxy to access any website you want as long as it is legal.',
  securityTrust: 'Trusted and Secure Proxy',
  langNetwork: 'No bandwidth limitations',
  productText:
    "Avoid blocked crawls and easily collect data with IPRocket's residential proxies. Utilize more than 60 million real IP addresses in over 210 countries and territories worldwide. Connect to the Internet from any location, device and browser of your choice.",
  houseNetworkTitle: 'Most Reliable Residential Proxies',
  houseNetworkText:
    'Support your web crawling projects with rotating residential proxies from a pool of over 60 million IPs. Residential IP addresses span the globe, so you can easily overcome geographic limitations.',
  houseNetworkTitle2: 'MultIPle network types',
  houseNetworkTitle3: 'Rotation and Sticky Sessions',
  houseNetworkText2: 'Choose between HTTP, fully encrypted HTTPS, or the fast and reliable SOCKS5 protocol.',
  houseNetworkText3: 'User customizable spinning and sticky sessions. Sticky sessions can last up to 60 minutes.',
  houseAgentTitle: 'High-performance and secure residential proxies',
  houseAgentText:
    "IPRocket's rotating residential proxis are built for high performance and security, and all connections are secure and encrypted to protect user data and activity. We offer 24/7 technical support so users can get help when they need it, ensuring uninterrupted service.",
  panelH1title: 'Case of Price Monitoring',
  panelH2title1: 'Real-time price monitoring',
  panelH2title2: 'Data-driven decision-making',
  panelH2title3: 'Get location-based pricing ',
  panelText1:
    "In today's e-commerce marketplace, online retailers are faced with an increasingly complex and fast-changing environment as competition intensifies and consumer demands diversify. Making thousands of price adjustments per day has become the norm, and monitoring such changes manually is clearly impossible. As a result, e-commerce professionals are increasingly relying on advanced web intelligence solutions, such as the utilization of IPRocket proxies, for automated real-time data transfer and price monitoring to remain competitive in the marketplace and improve operational efficiency.",
  panelText2:
    "IPRocket Proxy provides online retailers with a real-time price monitoring solution. It is able to automatically capture and analyze competitors' price adjustments, helping companies to react quickly and maintain a competitive edge in the market. Enterprises can make timely adjustments to their pricing strategies through real-time data transmission and processing to ensure that they maintain reasonable and competitive pricing levels in the midst of fierce price competition.",
  panelText3:
    "IPRocket Proxy helps organizations intelligently manage and operate their e-commerce businesses. By integrating and analyzing various open data sources, such as competitors' pricing information and market trend analysis, enterprises are able to develop more accurate and effective market strategies. This data-driven decision-making approach not only improves an organization's decision-making efficiency, but also enhances its market agility and adaptability, making it invincible in the highly competitive e-commerce market.",
  panelText4:
    'Pricing information varies from site to site and can be affected by geographic location - even the same vendor may change prices based on country or currency. As a result, retrieving the data you need from a specific location can be difficult. the IPRocket proxy covers more than 190 countries and territories around the world and provides city-level targeting, allowing companies to access pricing data from anywhere.',
  panelComponenttip1: 'No concurrent session limit',
  marketH1: 'Case of Market Research',
  marketText1:
    'With over 60 million residential proxies available, IPRocket provides a powerful tool for organizations to gain competitive intelligence in a highly competitive market. With a diverse selection of IP sources and geographic locations,organizations are able to easily track competitor activity, not only avoiding problems of being blocked or encountering CAPTCHAs, but also accurately grasping market dynamics and developing responsive marketing strategies. When choosing a market intelligence tool, organizations should consider the highly effective solutions offered by IPRocket to help them maintain a competitive edge in a highly competitive environment.',
  marketH2Title1: 'Large-scale market research and statistics',
  marketH2Title2: 'Competitor Analysis',
  marketH2Title3: "Consumers' Preference Analysis",
  marketText2:
    'IPRocket offers a variety of helpful features when evaluating potential new markets. First, through its global residential IP network, users are able to access accurate local market data. For example, websites for specific countries or regions can be accessed to obtain real-time sales data, consumer behavior patterns, and market trends. The accuracy and timeliness of this data far exceeds traditional sampling methods because it is collected directly from real consumers, avoiding the risk of sample distortion.',
  marketText3:
    "You can use IPRocket to monitor competitors' activities around the world, including their advertising strategies, pricing tactics, and product promotion methods, which provides insight into the competitive landscape and market share distribution. This in-depth analysis provides important data support for companies to make strategic decisions that help them gain a competitive advantage in new markets.",
  marketText4:
    'By analyzing consumer behavior and preferences in different geographic locations, companies can better understand how to adjust their products or services to fit the needs of the local market. For example, market positioning, product feature design, or marketing strategies can be adjusted based on the data obtained by using IPRocket Proxy, thereby increasing the success rate of market entry.',
  AdvertisementH1: 'Case of Ad Verificatgion',
  AdvertisementH2title2: 'Collect relevant advertising information',
  AdvertisementH2title3: 'Avoid wasting advertising budget',
  AdvertisementH2title4: 'Avoid wasting advertising budget',
  AdvertisementText1:
    "In today's digital marketing era, Ad optimization using real residential IP addresses from all over the world has become an important tool for companies to improve ad effectiveness and optimize their strategies. Residential IP proxies not only circumvent complex bot detection, but also provide a real user's perspective and in-depth analysis of how ads perform across regions, demographics and devices, providing advertisers with valuable optimization data.",
  AdvertisementText2:
    'The main advantage of residential IP proxies is their ability to simulate real user environments, ensuring that ads are displayed in actual browsers with real click and conversion data. This approach allows advertisers to accurately evaluate the effectiveness of their ads and understand how ads perform differently across geographic locations, demographics, and device types, so they can target and optimize their ad strategies.',
  AdvertisementText3:
    "IPRocket's Residential Proxy is also able to promptly identify and respond to suspicious activity such as clickbot manIPulation, protecting advertising budgets from wasteful and fraudulent behavior. By analyzing abnormal behaviors such as quick clicks initiated from the same IP address, the Residential IP Proxy helps advertisers quickly respond and adjust their strategies to ensure the effectiveness and sustainability of their advertising campaigns.",
  AdvertisementText4:
    'Advertisers should make full use of the technical advantages of Residential IP Proxies to deeply analyze ad effectiveness and optimize ad placement, so as to achieve more accurate and effective marketing goals. As the digital advertising environment continues to evolve and become more complex, Residential IP Proxies will continue to be an important tool for improving ad ROI and protecting placement security.',
  EngineH1: 'Case of SEO Optimization',
  EngineH2Title2: 'Reliability of SEO and SERP Proxies',
  EngineH2Title3: 'Low Cost SEO and SERP Proxy',
  EngineH2Title4: 'Huge IP Pools',
  EngineText1:
    "In today's digital age, SEO has become one of the key strategies for businesses and individual websites to boost online visibility and traffic. However, a common problem faced by many websites is that search engines restrict and block access to IP addresses, making it difficult for websites to be crawled and indexed effectively. To combat this challenge, the use of residential proxy IPs has become a common and effective solution.",
  EngineText2:
    "IPRocket Rotating SEO & SERP Proxy is known for its high level of reliability. Organizations need stable and continuous services in data collection so that data integrity and accuracy can be ensured. Our proxy services ensure high availability and low failure rates through advanced technology and stable infrastructure. Whether it's a short-term project or long-term monitoring, our services provide consistent performance that meets the diverse needs of organizations.",
  EngineText3:
    'While traditional data collection methods often require high investment and complex maintenance, our rotational proxy service greatly reduces these costs. Through optimized resource allocation and an efficient operating model, we are able to offer competitive pricing to our clients, enabling companies to obtain high-quality data support with lower budgets, thus enhancing overall economic efficiency. Our residential IP prices start from as low as $0.9/GB.',
  EngineText4:
    'High-quatity IP address is another highlight of our service. The use of multIPle IP addresses during the data collection process effectively avoids blocking and restriction by search engines. We have a huge number of IP addresses in our proxy pool, and these addresses are widely distributed, covering all regions of the world. Such IP diversity not only improves the success rate of data collection, but also ensures the breadth and representativeness of the data, enabling organizations to obtain more comprehensive and accurate market intelligence.',
  DataH1: 'Case of Data Collection',
  DataH2Title2: 'Massive Web Scraping Made Easy',
  DataH2Title3: 'How can IPRocket help you with data scraping?',
  DataH2Title4: 'Scope of application of data scraping',
  DataText1:
    "Data scraping plays a vital role in today's personal and professional applications. Whether for market research, competitive intelligence, or business development, proxy services are a critical tool for ensuring data security and freedom of access. IPRocket offers a wide range of highly efficient residential proxy options, coupled with advanced geo-location technology, allowing users to easily access accurate data worldwide, regardless of geographic constraints. Whether your data needs are national or city-level, IPRocket's excellent residential proxy services can significantly improve the efficiency and success of data crawling.",
  DataText2:
    'IPRocket offers solutions that provide organizations with highly efficient data scraping tools that can easily capture thousands of pages of data. Through its advanced technology and robust network architecture, IPRocket not only ensures efficient data capture, but also guarantees data quality and accuracy. This capability enables enterprises to maximize the potential of big data to better understand the market environment, optimize operational strategies, and achieve business growth.',
  DataText3:
    'Our network pool provides residential IP addresses from real home devices, each of which can be used to crawl proxies. These residential proxies rarely trigger human authentication (CAPTCHA), making them ideal for effective network crawling. Our network covers more than 210 countries and territories with tens of millions of IP addresses, helping you to easily break through geographic constraints and freely access a wide range of content. In addition, our residential proxies significantly reduce the risk of blocking and duplication rates.',
  DataText4:
    'Including but not limited to: business market analysis, social media mining, e-commerce data analysis, scientific research and academic data collection, news and media monitoring, financial market analysis, and healthcare data collection and analysis.',
  TravelH1: 'Case of Travel Fare Summary',
  TravelH2Title2: 'Differences from traditional travel fare scraping',
  TravelH2Title3: 'Advantages of IPRocket Proxy in Travel Fare Summarization',
  TravelH2Title4: 'Compare prices like a professional',
  TravelText1:
    "In order to increase the success and speed of travel fare crawling, as well as to avoid the problem of IP blocking by airlines, railroads and travel proxies, IPRocket's Residential Proxy provides an effective solution. In today's digital age, accessing any airline website or other travel service provider, whether on a desktop or mobile device, requires ensuring that a real residential IP address is used to avoid access restrictions and data fragmentation.",
  TravelText2:
    "Traditional travel fare capture tools can be plagued by IP blocking and access restrictions, which limit the accuracy and real-time nature of data collection. However, with IPRocket's Residential Proxy service, users can easily emulate the access behavior of real users to gain unimpeded access to any airline, railroad, or travel proxy's website. This service utilizes a large pool of residential IP proxies to ensure that users can send unlimited concurrent connection requests, taking crawling tools to a whole new level of efficiency.",
  TravelText3:
    'First, they can avoid access restrictions due to IP blocking, ensuring that they can access flight fares and seat information in real time. Secondly, they can improve the success rate and speed of the capture tool, as real residential IP addresses make data collection more stable and reliable. Most importantly, this service provides users with a legitimate and effective way to help them compete effectively in the market and improve service quality.',
  TravelText4:
    "Websites often display different prices depending on your location. Residential proxies allow you to go to websites in different countries and display prices that are not visible to your local IP, thus gaining access to deals that airlines and hotels don't want you to know about. IPRocket solves the geo-restricted problem faced by the travel and hospitality industry with a large pool of residential proxies, providing businesses with an effective solution for global data collection and analysis.",
  MotionH1: 'Case of Sneaker and Ticket',
  MotionH2Title2: 'Why can IPRocket be your sneaker proxy?',
  MotionH2Title3: 'IPRocket will protect your purchase from start to finish',
  MotionH2Title4: 'Limited sneakers/tickets up for grabs in global regions',
  MotionText1:
    'In the current online retail market, limited edition sneakers and show tickets are in high demand due to their scarce availability, often being snapped up within mere seconds of release. For avid sneaker or show consumers, access to these unique shoes or rare show tickets has become a competition of skill and speed, with high-quality IP proxies at their disposal.',
  MotionText2:
    'Our IP proxies are specifically designed to optimize the buying experience. By connecting to the proxy server closest to the target server, consumers are able to dramatically reduce response times and network latency during the ordering process. When limited edition sneakers are on sale, every second can make or break an order. As a result, the fast response time of the sneaker IP proxy allows consumers to get the latest inventory information in the shortest possible time and complete the purchase process as quickly as possible, increasing the chances of a successful purchase.',
  MotionText3:
    "When making online purchases, consumers' personal and payment information needs to be effectively protected from the risk of cyber attacks or information leakage. By using proxies, consumers can hide their real IP address and geographic location, reducing the risk of being tracked or attacked, and thus making purchases and transactions more secure.",
  MotionText4:
    'You can choose proxies in different regions to obtain more versions of limited edition sneakers or show tickets or particIPate in different on-sale events across regions, depending on your needs. This flexibility not only increases the chances of a successful purchase, but also meets the diverse needs and preferences of consumers, making it easier for them to obtain their favorite sneaker styles or show tickets.',
  SaleH1: 'Case of Selling and E-commerce',
  SaleH2Title2: 'Residential proxy for competitive analysis',
  SaleH2Title3: 'Protect your brand',
  SaleH2Title4: 'Explore new consumers and distributions',
  SaleText1:
    "In today's era of globalization and digitization, organizations face an increasingly complex and competitive environment. IPRocket Proxy is a powerful tool that provides organizations with the unique ability to better manage and adapt to this challenging environment.",
  SaleText2:
    "IPRocket IPRocket Proxy allows organizations to conduct comprehensive market analysis and competitor monitoring. Enterprises can collect and analyze market data in real-time to understand competitors' pricing strategies, product features, and market share trends. This comprehensive analysis not only helps companies better position themselves in the market, but also identifies market opportunities and potential threats!",
  SaleText3:
    'By using IPRocket proxy, organizations can protect their brands from malicious attacks and competitors. This protection is not limited to network security, but also includes protection in marketing and brand management. For example, organizations can use proxy servers to deceive competitors, preventing them from accessing critical information or damaging their reputation and brand value through malicious means.',
  SaleText4:
    'IPRocket By using IPRocket proxy, organizations can protect their brands from malicious attacks and competitors. This protection is not limited to network security, but also includes protection in marketing and brand management. For example, organizations can use proxy servers to deceive competitors, preventing them from accessing critical information or damaging their reputation and brand value through malicious means.',
  EmailH1: 'Case of Email Protection',
  EmailH2Title2: 'Securing Email ',
  EmailH2Title3: 'Identify potential risks and threats ',
  EmailH2Title4: 'Keep anonymity and security ',
  EmailText1:
    "In today's digital age, email has become an important communication tool for organizations and individuals. However, with it come threats to email security, such as malware and data breaches, which can lead to serious information security issues. To effectively protect sensitive email communications and help organizations avoid cyberattacks, cybersecurity companies rely on high-quality IP proxies to scan emails from different IP addresses.",
  EmailText2:
    'Reliable IP proxy providers such as IPRocket play a key role in email security. They ensure that cybersecurity companies are able to perform email scanning 24/7 and detect potential security threats in a timely manner by providing a stable service with almost 100% uptime. These proxies not only provide anonymity, but also effectively hide the true identity of the scanner, preventing the attacked from realizing their scanning activities.',
  EmailText3:
    'Cybersecurity companies utilize IP proxies to scan emails to identify possible risks and threats. This includes detecting possible data leaks, malicious attachments, and other potential security vulnerabilities. By sending and receiving emails from different IP addresses, they are able to simulate diverse network environments and more fully assess the security of email content.',
  EmailText4:
    "In order to successfully scan emails, it is vital to remain anonymous and undetectable. IPRocket Proxy ensures that a network security company's scanning campaigns are undetectable to attackers by hiding their real IP addresses. This anonymity not only protects the identity of the scanner, but also ensures the effectiveness and validity of the scanning activity, thus better protecting email security and confidentiality.",
  MarketingH1: 'Case of Social Media Marketing',
  MarketingH2Title2: 'Content promotion and influencer marketing ',
  MarketingH2Title3: 'Social Media Marketing and Market Research ',
  MarketingH2Title4: "Build your brand's reputation ",
  MarketingText1:
    "In order to take control of the niche market in the social media space, intelligent marketing campaigns have become crucial by developing strategies that anticIPate future trends. In today's digital age, social media platforms have become an important bridge for communication and interaction between businesses and consumers. By using IPRocket proxies for automated and routine data collection systems, organizations can easily collect up-to-date and authentic data from major social media platforms.",
  MarketingText2:
    "Marketing campaigns help organizations accurately reach and influence their target audience through a data-driven approach. By collecting data through IPRocket proxies, businesses can gain real-time insights into customer behavior and preferences to gain a deeper understanding of the customer's journey and current needs. This in-depth understanding of the customer enables companies to conduct marketing campaigns in a more precise and personalized manner, thereby increasing the efficiency and return on marketing campaigns",
  MarketingText3:
    'Social media marketing offers a number of benefits to businesses of all sizes. For starters, it provides a cost-effective way to reach a large audience. By creating engaging and relevant content, businesses can attract followers and increase brand awareness. Second, social media allows for targeted advertising, which means businesses can reach their ideal customers with precision. Third, social media provides valuable insights into customer behavior and preferences that can inform marketing strategies and product development.',
  MarketingText4:
    'Social media marketing campaigns help companies build brand reputation and user loyalty on social media by creating content that resonates deeply with their audience. This content strategy, which is highly aligned with the needs of the audience, not only increases user engagement and interaction, but also helps to increase the reach and visibility of the brand on social media platforms.',
  otherDemoTitele: 'View other cases',
  data: 'Data Collection',
  market: 'Market Research',
  Sale: 'Selling and E-commerce',
  Motion: 'Sneaker and Ticket Bots',
  Travel: 'Travel Fare aggregation',
  Engine: 'SEO and SERP',
  Price: 'Price Monitoring',
  Email: 'E-mail Protection',
  Advertisement: 'Ad Verificatgion',

  chartGPTH1: 'The Most Reliable ChatGPT Proxy ',
  chartGPTH2T2: 'Security and Anonymity ',
  chartGPTH2T3: 'Natural Language Processing, Machine Learning ',
  chartGPTH2T4: 'Enhance Innovation and competitiveness ',
  chartGPTText1:
    'In order to unleash the full potential of AI conversations, it is vital to use ChatGPT proxies, an advanced AI technology that is revolutionizing the way we interact online, dramatically impacting our learning and problem solving processes. Whether you are delving into the frontiers of AI, automating your customer service needs, or simply exploring the possibilities of AI technology, IPRocket Residential Proxies can ensure that you are able to securely and smoothly connect to the ChatGPT platform. ',
  chartGPTText2:
    'In the current fast-moving tech environment, faced with the challenges of many AI-driven projects, it is critical to ensure high efficiency and freedom from slowdowns or bottlenecks. IPRocket Residential Proxy not only provides high-speed and reliable access, but more importantly guarantees anonymity and the ability to bypass any potential limitations, providing developers, researchers, and others applying AI technology with back-end support and secure Pass.',
  chartGPTText3:
    "For developers, the use of ChatGPT proxies means being able to focus on innovation and application development of AI technologies without the distraction of external constraints. Researchers, on the other hand, can rely on our proxies to dig deeper into all areas of AI, whether it's natural language processing, machine learning or the development of intelligent decision-making systems.",
  chartGPTText4:
    'As global competition for AI technology grows, organizations and individuals need to stay ahead of the competition through more efficient AI applications.The use of ChatGPT proxies is not just a technology choice, but a strategic decision that can help users effectively manage and operate multIPle AI-driven projects while remaining innovative. This support is not just technical, it is a positive contribution to the strategic development of the organization.',

  discordH1: 'The Most Reliable Discord Proxy ',
  discordH2T2: 'Strict prohibition system ',
  discordH2T3: 'Using IPRocket proxies to circumvent the ban ',
  discordH2T4: 'Avoid encountering anti-robot measures',
  discordText1:
    'With more and more people choosing to work, play games and socialize from home, this group chat platform has quickly gained popularity and widespread use over the past few years.Unlike traditional social media platforms, Discord offers a versatile environment that combines real-time chat, voice, and video capabilities, allowing users to communicate and interact with like-minded people. ',
  discordText2:
    'While Discord offers a rich and colorful social experience, it also faces some challenges, especially in managing users and content.One of the controversial aspects of Discord is its IP banning system. This system is designed to prevent malicious users, undesirable content, and other violations, but it can sometimes hurt normal users. In particular, users who are on public or regional networks may be misjudged or banned from the Discord platform because they share the same IP address as other offending users.',
  discordText3:
    "To get around these restrictions, many users choose to use Discord proxy servers. Proxy servers help users circumvent IP bans and other geo-restrictions by hiding the user's real IP address and providing a proxy IP address. This technology not only allows users to continue to access and use Discord, but also protects their privacy and security from the risk of identity exposure and information leakage.",
  discordText4:
    "Discord has taken steps to prevent automated bots from abusing the platform. By using residential proxies, you can distribute bot requests to different IP addresses, making it more difficult for Discord's anti-bot systems to detect and block your bots.IPRocket's residential proxies add an extra layer of privacy and security to your Discord campaigns. They help protect your personal information and reduce the risk of targeted attacks or unauthorized access.",

  facebookH1: 'The Most Reliable Facebook Proxy ',
  facebookH2T2: 'Enhancing Facebook Privacy Protection ',
  facebookH2T3: 'Manage multIPle Facebook accounts efficiently ',
  facebookH2T4: 'Customize content to engage with specific audiences ',
  facebookText1:
    "In today's era of prevalent digital social platforms, how to effectively manage and protect multIPle personal or business accounts on Facebook has become an important concern for many users. IPRocket Residential Proxy provides an effective solution that not only enhances the level of privacy protection, but also helps users to efficiently manage and expand their social media accounts. ",
  facebookText2:
    "Using IPRocket Residential IP Proxy can effectively protect users' privacy. Traditionally, social platforms such as Facebook are at risk for multIPle accounts under the same IP address, which may be considered a violation of regulations and subject to restrictions or even blocking. By using a residential IP proxy, users can easily switch between different IP addresses, avoiding security risks caused by IP-related issues and protecting the security and privacy of personal or business accounts.",
  facebookText3:
    'For individuals or businesses that need to manage multIPle Facebook accounts, the IPRocket Residential I Proxy provides a convenient and efficient solution. With the proxy, users can log in and manage multIPle accounts at the same time without worrying about account violations being detected. This flexibility not only saves time and effort, but also effectively avoids the risk of banning due to improper account management.',
  facebookText4:
    'IPRocket Residential Proxy also helps individuals or businesses customize their content and engage with specific target audiences. By selecting IP addresses from different geographic locations, users can locate and engage audiences in specific regions or demographics, enhancing the personalization and appeal of their content. This precise targeting capability not only enhances the distribution of content, but also helps establish and maintain a unique online identity and brand image.',

  instagramH1: 'The Most Reliable Instagram Proxy ',
  instagramH2T2: 'Instagram Privacy and Security Awareness ',
  instagramH2T3: 'Optimize browsing experience and geolocation',
  instagramH2T4: "Why should you use IPRocket's Instagram proxy? ",
  instagramText1:
    "When using social media platforms such as Instagram, users need to protect their personal information from malicious users or cyber-attacks.IPRocket proxy provides an effective solution to secure users' devices and personal information by hiding their real IP addresses. At the same time, IPRocket's residential IP resources cover more than 210 regions, providing users with the option to optimize network connectivity and geo-location functionality, which significantly improves browsing performance and experience on Instagram.",
  instagramText2:
    "In today's Internet environment, personal privacy protection is crucial. Especially when using social media platforms, how to effectively protect personal information from cyber threats has become the focus of users' attention. IPRocket, as an effective proxy service tool, can help users hide their real IP addresses, thus effectively preventing possible malicious users or cyber attacks, and ensuring users' security and privacy protection when using Instagram.",
  instagramText3:
    "By connecting to proxy server nodes closer to Instagram servers, IPRocket proxies allow users to experience faster loading speeds and smoother browsing processes. In addition, IPRocket's residential IP resources cover more than 210 regions around the world, so users can easily select the IP address of their target city for access and realize the geo-location function.",
  instagramText4:
    'IPRocket plays an important role in protecting user privacy and enhancing the Instagram experience. By hiding real IP addresses and providing optimized network connections, IPRocket effectively reduces the cybersecurity risks faced by users and significantly improves the browsing efficiency and operating experience on the Instagram platform. In the future, IPRocket will continue to provide users with secure and reliable proxy services as the network environment continues to evolve.',

  pinterestH1: 'The Most Reliable Pinsterest Proxy ',
  pinterestH2T2: 'Create an Unlimited Number of Pinterest Accounts ',
  pinterestH2T3: 'Automate everything with Pinterest bots ',
  pinterestH2T4: 'Unlimited threads and connections',
  pinterestText1:
    "When using social media platforms such as Pinterest, how to effectively customize content, interact with specific audiences, and protect one's personal or business identity online has become a major concern for users. ipRocket Residential IP Proxy helps users set up and optimize their Pinterest accounts by providing secure network connections and anonymous browsing capabilities, including profile settings, board creation and content organization, enhancing users' experience and effectiveness on the platform.",
  pinterestText2:
    "Residential Proxy allows an unlimited number of accounts through its inherent hidden IP address feature. If any account receives a spam report that results in a ban, don't worry as you can create another one. In addition, various Pinterest automation tools require the use of a large number of synchronized accounts in order to run correctly and efficiently. This means that you can efficiently manage numerous accounts and multiply your followers with the best Pinterest proxy.",
  pinterestText3:
    "Pinterest and other social media platforms don't like bots or automated software. That's why it's important to use a proxy to hide your IP address.The Pinterest proxy can be used with any combination of browsers, APIs, bots, and custom software.IPRocket's Residential Proxy is very trustworthy, and it enables bots by hiding the number of requests that automation tools need to send. Automated pinning operations can greatly increase your reach as a creator, as people will notice your content more frequently.",
  pinterestText4:
    "When you sign up for a Pinterest proxy using IPRocket, you'll have access to over 8,000w global proxy IPs.With residential proxies to unblock Pinterest, there are no concurrency limits or bandwidth constraints, and everything you need to organize proxies for your Pinterest account is at your fingertips. ",

  redditH1: 'The Most Reliable Reddit Proxy ',
  redditH2T2: 'Ensuring the privacy and security of your Reddit account ',
  redditH2T3: 'Avoid triggering rate limiting ',
  redditH2T4: 'Utilizing Reddit Voting Bots Efficiently ',
  redditText1:
    "In the current digital era, privacy protection and freedom of data access are growing concerns for web users. Especially when using social media and information sharing platforms such as Reddit, how to protect personal privacy and bypass geographic and API access restrictions have become the focus of users' attention. IPRocket Proxy, as an effective technical tool, not only protects users' privacy and security on Reddit, but also helps users to overcome API restrictions and access to restricted content, improving users' experience and data collection efficiency.",
  redditText2:
    'The proxy network acts as a bridge between your personal Internet address and Reddit. IPRocket proxies effectively protect the privacy and security of users using Reddit by providing them with a residential IP address and hiding their real Internet address information. ',
  redditText3:
    "Reddit's API has strict rate limiting, which can be a challenge for users who require large amounts of data access. By using residential proxies for IP rotation, users can access the API from multIPle different IP addresses, thus avoiding triggering Reddit's rate limit. Each residential IP address is treated as a separate user, which effectively improves the efficiency and success of data collection and allows users to utilize Reddit's API functionality more flexibly.",
  redditText4:
    'With Reddit being one of the most popular social media services today, getting people to view and vote on your posts can be a challenge. Voting bots can provide invaluable help to Reddit users, and all you need is multIPle Reddit accounts, bot software, and residential proxies. Focus your Reddit marketing on relevant areas by using residential proxies in specific countries or cities. Disguise your bots as real users on Reddit for localized marketing campaigns.',

  TIKTOKH1: 'The Most Reliable Tiktok Proxy ',
  TIKTOKH2T2: 'Sign up for a Tiktok account with IPRocket proxy!',
  TIKTOKH2T3: 'Global Regional Support ',
  TIKTOKH2T4: 'Stable Proxy Service ',
  TIKTOKText1:
    'To help merchants globalize and leverage TikTok, the emerging e-commerce platform, IPRocket Proxy provides a powerful tool. In the mobile era, TikTok has become the platform of choice for global entertainment, and its innovative content format and broad user base make it an ideal platform for merchants to promote their products and services.IPRocket Proxy helps merchants easily enter the TikTok marketplace, expand their business reach, and reach more global users by providing IP registration services across the globe, so that their businesses can business development.',
  TIKTOKText2:
    "With such a booming TikTok platform, how merchants can effectively utilize their global user resources has become a key issue. IPRocket Proxy provides an innovative solution to help merchants register TikTok accounts and promote campaigns all over the world through its global IP registration service. This service is not only a simple technical support, but also an important support for merchants' global market strategy.",
  TIKTOKText3:
    'IPRocket Proxy enables merchants to go live with TikTok accounts in markets such as the UK, US, Malaysia, PhilIPpines, Thailand, Vietnam, Singapore, etc. by providing multi-localized IP address registration services, thus directly reaching out to local user groups. This localized registration helps merchants avoid geographic restrictions and language barriers, and more effectively communicate and interact with their target markets.',
  TIKTOKText4:
    'IPRocket Proxy also ensures that merchants are able to run stable promotions when using the TikTok platform through optimized network connections and stable proxy services, avoiding operational problems and delays due to geographic location or network limitations. This professional technical support not only improves the user experience of merchants on TikTok, but also guarantees the effectiveness and efficiency of promotional campaigns.',

  twitchH1: 'The Most Reliable Twitch Proxy ',
  twitchH2T2: 'Protecting Twitch account security and privacy ',
  twitchH2T3: 'Global audience discovery and interaction ',
  twitchH2T4: 'Enhanced flexibility and control ',
  twitchText1:
    "Twitch, the world's largest live gaming platform, attracts millions of viewers and content creators. However, as its user base expands and the size of the platform increases, security and privacy protection become more and more important. Using a Twitch proxy has become the preferred choice for many users, not only to ensure the stability and security of streaming transmission, but also to effectively avoid some potential risks and restrictions.",
  twitchText2:
    'The Twitch platform has very strict security measures in place for accounts, and any violation of the rules may result in the account being banned or otherwise sanctioned. Using a Twitch proxy can help users hide their real IP address, reduce the risk of suffering from IP-related issues, and protect the security and privacy of their account.',
  twitchText3:
    'Utilizing Twitch proxies, users can easily access Twitch channels around the world, expanding the geographic reach of their audience. This globalized viewer interaction not only increases viewershIP, but also provides content creators with more diverse viewer feedback and interaction opportunities, making live content more engaging and interactive.',
  twitchText4:
    'For Twitch hosts and content producers, proxies offer greater flexibility and control. They can optimize the quality and stability of their live streams by selecting servers in specific regions through proxies, while managing and expanding their viewer base globally. This capability not only enhances the professionalism of live streaming, but also brings content closer to the needs and preferences of viewers.',

  youtubeH1: 'The Most Reliable Youtube Proxy ',
  youtubeH2T2: 'Privacy and anonymous access ',
  youtubeH2T3: 'Circumvent IP access restrictions ',
  youtubeH2T4: 'Anti-robot measures ',
  youtubeText1:
    "When using widespread social media platforms such as Youtube, Residential Proxy provides users with an important privacy-protecting feature by replacing your real IP address with the IP address of your residential location. In addition to this, it can be used to manage multIPle Youtube accounts, bypass IP-based access restrictions, and counter the platform's anti-bot measures for a safer and more flexible user experience.",
  youtubeText2:
    "When using social media video platforms such as Youtube, a user's personal information and browsing behavior may be tracked and collected, so it is especially important to protect personal identity and privacy. IPRocket's Residential Proxy, as a technological solution, effectively replaces a user's real IP address and hides his or her real location information, thus protecting the privacy and anonymity of users when using Youtube. and anonymity when using Youtube.",
  youtubeText3:
    "In some cases, users may be subject to Youtube's access restrictions due to geographic location or other factors, such as server access limitations or rate limitations. IPRocket's Residential Proxy enhances the flexibility and convenience of the platform for users by providing IP addresses from various residential locations, allowing users to bypass these restrictions and freely access the content or functionality they desire.",
  youtubeText4:
    "Youtube, the world's leading video sharing platform, also faces the challenge of bot abuse. To combat this problem, Youtube has taken a variety of anti-bot measures, including detecting and blocking inappropriate bot behavior. IPRocket's residential proxies are able to distribute bot requests to a variety of IP addresses, making it more difficult for Youtube's anti-bot system to detect and block users' botting, thereby protecting users' legitimate usage rights.",

  airbnbH1: 'The Most Reliable Airbnb Proxy ',
  airbnbH2T2: 'Acquire more property listings',
  airbnbH2T3: 'Avoid encountering robotic validation',
  airbnbH2T4: 'Give your business a competitive edge',
  airbnbText1:
    "Airbnb, short for 'AirBed and Breakfast,' is an online marketplace where homeowners can rent out their properties to travelers on a short-term basis. Airbnb itself doesn't own any properties; it merely acts as an intermediary between the homeowners and the renters. Travelers can find and rent private rooms that accommodate multIPle people, or even rent entire homes.",
  airbnbText2:
    "Airbnb has become a popular alternative to the hotel industry, and its growing popularity has led to more listings and thus more options for users. In fact, there are currently over 6 million listings on Airbnb. That's a lot of valuable property listing data that people can use for a variety of purposes, so if you want to extract all of that data, then you need to use IPRocket Residential Proxy to grab it.",
  airbnbText3:
    "The Airbnb proxy will handle all the data traffic for you, thus hiding the IP addresses of any websites you visit or applications you use, and they will only see the IP address of the proxy server. By constantly rotating these IPs and using the best Airbnb proxy (i.e., a residential proxy), your crawlbot will have a different IP address every time it sends a request and effectively trick any website into thinking that your bot's request is coming from a real user.",
  airbnbText4:
    "With the growing importance of data in today's business decisions, rational and effective utilization of the Airbnb proxy has become a necessity for many businesses and individuals. Through these technological tools, users can make smarter competitive market analyses, real estate investment decisions, and service optimization, bringing their businesses sustained competitive advantage and growth opportunities.",

  amazonH1: 'The Most Reliable Amazon Proxy ',
  amazonH2T2: 'Scrape product pricing',
  amazonH2T3: 'Monitor your competitors',
  amazonH2T4: 'Get reviews and feedback on each brand',
  amazonText1:
    "In order to gain a competitive advantage in a highly competitive marketplace, using IPRocket Residential Proxy to crawl the hottest data on Amazon is a key strategy.IPRocket Residential Proxy provides a stable and efficient data crawling service, which can help users gain insights into the pricing strategies of different marketplaces, monitor competitor's product dynamics, collect customer reviews, and stay up-to-date with the latest market trends.",
  amazonText2:
    'By using the IPRocket Residential Proxy, users can capture and analyze pricing information for each market in real-time. This includes pricing differences across regions and countries, helping users develop precise pricing strategies to remain competitive in different markets. For example, by comparing the pricing of similar products in different markets, users can determine the best time to reduce or increase prices in certain markets, thereby optimizing product pricing strategies and increasing sales efficiency and market share.',
  amazonText3:
    "In addition to pricing strategy, monitoring competitors' products is another key point. IPRocket Residential Proxy is able to capture competitors' product lists, features and inventory in real-time. By analyzing this data, users can understand competitors' product strengths and market positioning, and promptly adjust their product portfolio and marketing strategies to enhance competitiveness and capture market share.",
  amazonText4:
    'IPRocket Proxy is also able to obtain customer reviews and feedbacks from various brands on the Amazon marketplace, helping users understand the latest market trends and consumer preferences. By analyzing these data, users can more accurately grasp market trends, adjust product promotion and marketing strategies in a timely manner, and improve market reaction speed and product sales efficiency.',

  ebeyH1: 'The Most Reliable eBay Proxy ',
  ebeyH2T2: 'Simple Ways to Get Higher Profits from eBay',
  ebeyH2T3: 'Let multIPle accounts assist you in bidding',
  ebeyH2T4: 'Avoid triggering the eBay protection',
  ebeyText1:
    'eBay is one of the largest auction sites on the Internet. eBay was founded in 1995 and currently processes millions of auctions every day. In order to take full advantage of eBay, users need to have nerves of steel and quick reflexes to snap up the best items at the lowest prices. For the best eBay experience, eBay Proxies automate many of the day-to-day bidding tasks, giving you value for money. We will highlight the many benefits of using an eBay proxy and how to find the best options.',
  ebeyText2:
    "Finding great deals on eBay can be an adventure. With tons of items coming online every minute, keeping track of hot new deals can easily turn into a full-time job. Plus, when you're particIPating in a high-energy auction, every millisecond wasted can be a missed opportunity. An auction snIPer can strike quickly and win items at the last minute. Aside from sitting at a desk all day with no social life, is there a way to ensure you win auctions? There is! By using high quality proxies, you can get your favorite auction items with ease.",
  ebeyText3:
    'Another benefit of eBay proxies is the ability to create multIPle accounts. eBay usually only allows one account for a user, but with a reliable proxy you can create multIPle accounts for bots to use. Each account is unique because the proxy hides your IP address. With multIPle accounts, you can bid on several items at the same time and increase the success of your auctions by placing bids. If you try to do this without a proxy, you may be blocked quickly.',
  ebeyText4:
    'When searching for the best deals on eBay, current price information is crucial. Since prices can change at lightning speed during frantic auctions, any delay in data can be disastrous. Fortunately, proxies can help gather accurate pricing information. If eBay detects a surge in requests, a security response may be triggered. To avoid being banned while collecting data, reliable, secure proxies are essential to ensure your IP address and host are protected.',

  etsyH1: 'The Most Reliable Etsy Proxy ',
  etsyH2T2: 'Identify best-selling products',
  etsyH2T3: 'Collecting reviews to observe consumer sentiment',
  etsyH2T4: 'Optimize your pricing, supply chain and marketing strategies',
  etsyText1:
    "In today's highly competitive e-commerce market, understanding and comparing competitors' product pricing and inventory is a key strategy for maintaining a competitive edge. Specifically on creative marketplace platforms like Etsy, using IPRocket residential proxies to regularly analyze market trends and consumer behavior can help sellers optimize their product strategies, increase sales efficiency, and expand market share.",
  etsyText2:
    "In order to stay ahead of the competition, it's crucial to understand and promote the best-selling products on Etsy. With IPRocket's residential proxy data crawl, you can get data on currently popular gifts and products and analyze their sales trends and consumer preferences. Especially during holidays and special category promotions, collecting and analyzing this data in a timely manner can help users seize market opportunities and boost sales and brand exposure.",
  etsyText3:
    'Consumer sentiment and feedback have a direct impact on product sales. By capturing product reviews and ratings on the Etsy platform, it is possible to gain insight into consumer attitudes and satisfaction with products. This data can not only help users optimize product design and quality, but also adjust marketing strategies to improve customer experience and loyalty.',
  etsyText4:
    "By comprehensively analyzing competitors' pricing strategies and product characteristics, users can optimize their pricing, supply chain and marketing strategies. For example, by discovering competitors' product matches and market research, they can better grasp market trends, changes in demand and customer behavior, so as to discover and develop new best-selling products and enhance market competitiveness and profitability.",

  mercariH1: 'The most reliable Mercari proxy',
  mercariH2T2: 'Why use the Mercari proxy?',
  mercariH2T3: 'Create multIPle macari accounts',
  mercariH2T4: 'Choose a reliable proxy service provider',
  mercariText1:
    'Mercari is a Japan-based online shopping platform founded in 2013. As an e-commerce platform that focuses on C2C (consumer-to-consumer) transactions, Mercari strives to provide an easy-to-use marketplace where users can buy and sell various types of goods, including clothing, home furnishings, electronics, and more.',
  mercariText2:
    "IPRocket's residential proxy masks a user's real IP address by routing their web requests to a legitimate residential IP address. This proxy is especially important in e-commerce because it helps sellers circumvent platform restrictions, such as IP blocking or geo-restrictions. This means sellers can access the Mercari platform more freely and take advantage of marketplace opportunities in different parts of the world.",
  mercariText3:
    'If you use mercari for marketing purposes, opening and running multIPle mercari accounts can help you reach a larger audience and attract more followers. However, mercari does not allow users to have multIPle accounts, so if you open more than one account, the mercari server will detect and block you. To prevent this from happening, you can use IPRocket Residential Proxy, where we will provide each account with a different IP address. This way, each of your accounts will appear to be from a different user and location, thus avoiding mercari bans.',
  mercariText4:
    "Effective ways to implement residential proxies include choosing a reliable service provider and ensuring the stability and security of the proxy IPs. These proxies not only help sellers maintain online anonymity, but also provide additional security to protect personal and financial information from cyber-attacks.With a pool of more than 60 million IP's, coverage of more than 210 countries worldwide, and a connection success rate of 99.05%, the IPRocket Residential Proxy is definitely the right choice for you.",

  shopifyH1: 'The Most Reliable Shopify Proxy ',
  shopifyH2T2: 'Why do most Shopify auto-checkout bots fail?',
  shopifyH2T3: 'Grab Shopify Data Without Restrictions',
  shopifyH2T4: 'What are the best proxy for Shopify?',
  shopifyText1:
    "In today's rapidly evolving e-commerce environment, using automated checkout bots for purchases on the Shopify platform is an attractive strategy. However, despite employing good proxy technology, most automated checkout bots still face a high risk of failure. This is mainly because Shopify excels at blocking bots and proxies, implementing multi-layered security measures to protect the fairness and legitimacy of its marketplace. Utilizing IPRocket residential proxies can help avoid such issues.",
  shopifyText2:
    "Shopify does a great job of detecting automated checkout bots. Because Shopify powers so many online eCommerce marketplaces, it's under a lot of pressure to block bots and proxies. That's why in most cases you can't use data center proxies to buy multIPle items - they'll be blocked in bulk.",
  shopifyText3:
    "Grab Shopify prices, product descrIPtions, and any other data using IPRocket's unlimited concurrent proxy connections. Get high speed, high success rates, and accurate local information through our network of premium residential Shopify proxies. Get on-demand access to country-specific IPs and never be blocked again.",
  shopifyText4:
    "Residential Proxy is the best proxy for Shopify. It replaces a real desktop or mobile device.Shopify specializes in detecting bots, so you'll need the most authentic IP address and the best software with a unique fingerprint for successful replication.",

  vintedH1: 'The most reliable Vinted proxy',
  vintedH2T2: 'Why do you need a Vinted proxy?',
  vintedH2T3: 'Data Encryption and Access Control',
  vintedH2T4: 'Improve your shopping or selling experience on Vinted',
  vintedText1:
    "Vinted is available on Android, iOS, and desktop browsers, allowing users to buy, sell, or exchange second-hand or brand-new clothing and accessories. This Lithuanian app is now available in 15 countries and regions, with over 45 million registered users. Sellers favor this platform because it doesn't charge any fees, while buyers appreciate it for finding unique items at affordable prices. However, for various reasons, Vinted may ban user accounts. Additionally, there is always some risk when shopping online using a debit or credit card. Therefore, using Vinted proxy services is a wise choice.",
  vintedText2:
    "The role of proxy servers on Vinted is to protect the user's privacy and increase the security of the account by hiding the user's real IP address. They act as a middleman, forwarding data exchanges between users and Vinted servers. Using a proxy server prevents Vinted from detecting unusual activity, such as excessive data scraping or frequent login operations, thus reducing the risk of account bans.",
  vintedText3:
    "The proxy server assigns a temporary IP address to the user, making it impossible for Vinted to recognize the user's true identity and location. Proxies typically encrypt data to ensure user privacy and security during data transmission. Proxy servers are also able to control and manage user access rights to increase account security and stability.",
  vintedText4:
    'By rotating IP addresses and simulating the access behavior of real users, proxy servers can help users avoid having their accounts banned by Vinted for excessive activity. Using proxy servers for data crawling and analysis can dramatically increase efficiency, quickly obtaining the information needed and making decisions accordingly. By selecting IP addresses in specific countries or regions, users can simulate visits from different geographic locations to understand demand and price trends in different markets.',

  walmartH1: 'The Most Reliable Walmart Proxy ',
  walmartH2T2: 'Why do you need a Walmart proxy?',
  walmartH2T3: 'What is a shopping robot?',
  walmartH2T4: 'Secure access to Walmart using proxies',
  walmartText1:
    "In recent years, we've seen some major brands shift their focus to the online space, with some stores even closing their physical locations. This trend indicates a transformation in the commercial sector, with online stores becoming increasingly profitable while brick-and-mortar stores are gradually being phased out. Retail giants like Walmart have recognized the advantages of the online shopping industry. The company has decided to join this trend by designing and offering an online store for its users. Let’s take a look at how Walmart's online store operates and why you might need proxies to use it effectively.",
  walmartText2:
    'When you use a proxy server in your automation solution, a series of bot requests will be assigned different IP addresses, making each request appear to come from a different device in a different location. This simple feature makes your traffic indistinguishable from other regular visitors, making you immune to detection and allowing you to continue retail bottling on the platform without any issues.',
  walmartText3:
    'Shopping bots are the process of purchasing products from an online store using automated software. The main tools used in this case are shopping bots. They search shopping sites and speed up the checkout process so that users can buy popular products in a flash. These bots are very efficient and useful for individuals looking to take advantage of limited edition sales and discounts.',
  walmartText4:
    "A shopping bot is a software solution that automates the checkout process. Unfortunately, automation using non-human traffic is prohibited on Walmart.com. Different shopping platforms have mechanisms to monitor suspicious requests and issue IP bans in case of any malicious activity. Therefore, the only way to avoid such bans is to use different IP addresses for a series of requests, which is where IPRocket's residential proxy comes in handy.",

  franceIPTitle: 'French',
  americaIPTitle: 'American',
  britainIPTitle: 'British',
  hongkongIPTitle: 'HongKong',
  philippinesIPTitle: 'Philippine',
  canadaIPTitle: 'Canadian',
  germanyIPTitle: 'German',
  japenIPTitle: 'Japanese',
  vietnamIPTitle: 'Vietnam',
  brazilIPTitle: 'Brazilian',
  moreIPTitle: 'More',

  franceIP: '1,129,487',
  americaIP: '3,878,341',
  britainIP: '2,130,564',
  hongkongIP: '547,098',
  philippinesIP: '802,093',
  canadaIP: '598,214',
  germanyIP: '738,758',
  japenIP: '420,711',
  vietnamIP: '689,609',
  brazilIP: '1,138,236',
  moreIP: '0',

  questionTitle1: 'What is a proxy?',
  questionTitle2: 'How do I get a French proxy?',
  questionTitle3: 'How can I check if my agent is working properly?',
  questionTitle4: 'What is residential proxies? ',
  questionText:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the France for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the French proxy!',

  more: 'View more',
  franceH1: 'The most reliable French proxy',
  franceH2T2: 'France proxy Prices',
  franceH2T3: "Why IPRocket's French Proxy is the Best Choice?",
  franceH2T4: "Who's fit to use a French proxy?",
  franceH2T5: "Why shouldn't you use a free French proxy?",
  franceH2T6: 'Q & A',
  franceH3: 'Proxy for the French cantons',
  franceText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 French IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium French proxies, you will undoubtedly enhance your proxy experience.",
  franceText2:
    'Chaumont, Chalons, St. Louis, Martinique, Pertuis, Cité de la Lot, Valon, St. Geraval, Forbach, Guadeloupe, Jémont, Allouin, Millau, Fougeres, Ouch, Azbroucq, Saint-Jean-des-Brères.',
  franceText3:
    'A reliable France proxy server offers many benefits to individual users, organizations and businesses. Our French proxy servers can be configured to monitor and control Internet usage, allowing you to block children or employees from accessing specific websites and services. They are perfect for tasks such as data crawling, internet marketing, ad verification, brand protection, market price monitoring, grabbing limited edition shoes and social media management.',
  franceText3_p2:
    "Whether you are a personal or business user, our proxies can prevent malware sites from invading your network and enhance your online security. By using a French IP address, you can look like you're in France even when you're somewhere else, gaining access to geo-restricted content on platforms like BBC iPlayer, Hulu or Netflix. With IPRocket, you can enjoy these far more advantages.",
  franceText4:
    'Free French proxies usually carry significant security and privacy risks. These proxies usually come from unreliable and ethically undesirable providers and can lead to future problems. ',
  franceText4_p2:
    'Malicious free France proxies may intercept login details and passwords, exposing your personal data. You have no way of knowing if someone is using your information or how they are using it. They may even sell your data to third parties for profit. ',
  franceText4_p3:
    "As appealing as they may seem, free French proxies are not a sustainable solution. Not only are they insecure, they are slow and unreliable. Who wants to browse using a slow connection? For a secure and efficient experience, we recommend that you use IPRocket's premium proxy service.",
  franceWhyTitle1: 'One of the fastest France. proxy service providers',
  franceWhyTitle2: 'ContinuoFrancely expanding pool of France proxies',
  franceWhyTitle3: 'Francee our France proxies to hide your identity.',
  franceWhyText1:
    'We are proud of the high-speed proxies that IPRocket offers in the France market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our France proxies are the ideal public web crawling tool.',
  franceWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  franceWhyText3:
    "When it comes to online privacy issues, many people are concerned about the large amount of data that the U.S. government may collect on its citizens and Internet users. For this reason, it is especially important to choose a reputable proxy service provider in the US. IPRocket's private proxy service greatly enhances your online privacy protection by effectively masking your real IP address and using strong encryption technology to protect your web traffic.",
  franceBtn: 'Grt France proxy',

  americaH1: 'The most reliable US proxy',
  americaH2T2: 'US proxy Prices',
  americaH2T3: "Why IPRocket's US Proxy is the Best Choice?",
  americaH2T4: 'Who should use a US proxy',
  americaH2T5: "Why shouldn't you use a free US proxy?",
  americaH2T6: 'Q & A',
  americaH3: 'U.S. State Proxies',
  americaText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 US IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium US proxies, you will undoubtedly enhance your proxy experience.",
  americaText2:
    'Alaska, Texas, Ohio, California, District of Columbia, Washington, Michigan, Hawaii, Minnesota, Georgia',
  americaText3:
    "The ways to use a U.S. proxy are endless. The United States is the most developed economy in the world, and thousands of businesses are looking for opportunities to expand their operations there. As a business, you can use proxies to gather market intelligence, verify ad effectiveness, get local Google search results pages, create multiple social media accounts, and more. Meanwhile, as a home user, you can access the largest library of streaming media and significantly improve your online privacy protection. The use of proxies is also crucial for journalists who are concerned about the security threats they may encounter when exposing criminal activity. With data breaches on the rise, there's no better time to invest in some online security measures.",
  americaText4:
    'The United States is a country with high technological power, but it also harbors sophisticated cyber criminals. Using free U.S. proxies can be a recipe for trouble, as these proxies often have weak or no security measures. Cybercriminals can easily exploit these vulnerabilities to gain access to your sensitive data. In the best case scenario, your information may be sold to advertisers. However, the consequences could be more serious, such as losing your bank credentials and suffering significant financial losses. To avoid these risks, choose a paid and quality U.S. agent for your online activities.',
  americaWhyTitle1: 'One of the fastest US. proxy service providers',
  americaWhyTitle2: 'Continuously expanding pool of US proxies',
  americaWhyTitle3: 'Use our US proxies to hide your identity.',
  americaWhyText1:
    'We are proud of the high-speed proxies that IPRocket offers in the US market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our US proxies are the ideal public web crawling tool.',
  americaWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  americaWhyText3:
    "We make sure that our Canadian proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Canadian proxies and make sure you don't have to deal with complicated integrations.",
  americaBtn: 'Get US Proxy ',

  britainH1: 'Most Reliable UK Proxy',
  britainH2T2: 'UK proxy Prices',
  britainH2T3: "Why IPRocket's UK Proxy is the Best Choice?",
  britainH2T4: 'Who should use a UK proxy',
  britainH2T5: "Why shouldn't you use a free UK proxy?",
  britainH2T6: 'Q & A',
  britainH3: 'Proxy for the UK cantons',
  britainText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 UK IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium UK proxies, you will undoubtedly enhance your proxy experience.",
  britainText2:
    'Cambridge, Scotland, Felton, Holbeach, Desborough, Ardrossan, Aylesford, Ickenham, Blandford Forum, Castleton, Kingstanton, Noel, Moseley, Mould, Charlton Kings, Ilflecombe',
  britainText3:
    'Proxies can be used by a wide range of businesses and regular internet users. Businesses gain significant benefits by being able to crawl online data, explore different markets and utilize proxies to enhance their digital marketing decisions. Our UK IP addresses allow business owners to control their social media marketing campaigns and provide anonymity to keep these corporate decisions confidential.',
  britainText3_p2:
    "The average Internet user will find proxies very helpful when accessing online content. If you're traveling outside of the UK, you may not be able to access BBC iPlayer, miss a once-in-a-lifetime sporting event, or be unable to watch a Netflix TV show that's only available in the U.K. IPRocket's proxies make it easy to bypass these geo-restrictions while enhancing your online security!",
  britainText4:
    "There are significant drawbacks to using free UK proxies. The main issue is security. Free proxies may expose your sensitive data to third parties, whether you're running a marketing campaign, data scraping or bypassing geo-restrictions. This information could be sold to advertisers, or worse, your personal credentials could be stolen, leading to serious consequences. In addition, sharing free proxies with multiple users can dramatically slow them down, causing connections to become very slow and frustrating. Moreover, free proxies usually carry malware that poses a significant risk to your device and all future activities. Therefore, it is highly recommended to choose a UK internet proxy like IPRocket that offers paid services.",
  britainWhyTitle1: 'One of the fastest UK. proxy service providers',
  britainWhyTitle2: 'Continuously expanding pool of UK proxies',
  britainWhyTitle3: 'Use our British proxy to hide your identity.',
  britainWhyText1:
    'We are proud of the high-speed proxies that IPRocket offers in the UK market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our US proxies are the ideal public web crawling tool.',
  britainWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  britainWhyText3:
    "When it comes to online privacy issues, many people are concerned about the possibility of the British government collecting large amounts of data on its citizens and Internet users. For this reason, it is especially important to choose a reputable proxy service provider in the U.K. IPRocket's private proxy service can greatly enhance your online privacy protection by effectively masking your real IP address and using strong encryption technology to protect your web traffic.",
  britainBtn: 'Get UK Proxy',

  hongkongH1: 'Most Reliable Hong Kong Proxy',
  hongkongH2T2: 'Hong Kong proxy Prices',
  hongkongH2T3: "Why IPRocket's Hong Kong Proxy is the Best Choice?",
  hongkongH2T4: 'Who should use a Hong Kong proxy',
  hongkongH2T5: "Why shouldn't you use a free Hong Kong proxy?",
  hongkongH2T6: 'Q & A',
  hongkongH3: 'Proxy for the Hong kong cantons',
  hongkongText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Hong Kong IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Hong Kong proxies, you will undoubtedly enhance your proxy experience.",
  hongkongText2: 'Central and Western, Kowloon, Kwai Tsing and Tsuen Wan Districts',
  hongkongText3:
    "IPRocket offers a variety of customization options to provide Hong Kong IP addresses for everyone's needs. Home users can enjoy streaming services, news sites, and lower prices on consumer goods while gaining enhanced privacy protection. Enterprise customers can utilize our proxy services to grab market data at the fastest speed possible to gain a competitive edge in a highly competitive marketplace. In today's market environment, successful investments can be very challenging without accurate data to back them up. Our Hong Kong proxy network ensures reliable data capture with zero downtime and 99.86% stable uptime. Please feel free to contact us for any further questions!",
  hongkongText4:
    'Free proxies usually cause more trouble than they are worth. Cybercriminals often target free proxy users because these services lack strong cybersecurity features. For example, free proxies may use outdated encryption algorithms (or no encryption at all), allowing cybercriminals to monitor your online activities and extract valuable data. This data can then be used to launch more sophisticated cyberattacks and infect your devices. Eventually, they can access your social media passwords, personal chat logs and bank details. The consequences can range from having your social media accounts blocked to having your bank accounts emptied. To avoid unnecessary risks, use a paid and reputable proxy service like IPRocket.',
  hongkongWhyTitle1: 'One of the fastest Hong Kong. proxy service providers',
  hongkongWhyTitle2: 'Continuously scalable Hong Kong proxy pool',
  hongkongWhyTitle3: 'Easy integration with Hong Kong proxy servers',
  hongkongWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Hong Kong market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Hong Kong proxies are the ideal public web crawling tool.',
  hongkongWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  hongkongWhyText3:
    "We make sure that our Hong Kong proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Hong Kong proxies and make sure you don't have to deal with complicated integrations.",
  hongkongBtn: 'Get Hong Kong Proxy',

  philippinesH1: 'Most Reliable Philippine Proxy',
  philippinesH2T2: 'Philippine proxy Prices',
  philippinesH2T3: "Why IPRocket's Philippine Proxy is the Best Choice?",
  philippinesH2T4: 'Who should use a Philippine proxy',
  philippinesH2T5: "Why shouldn't you use a free Philippine proxy?",
  philippinesH2T6: 'Q & A',
  philippinesH3: 'Proxy for the Philippine cantons',
  philippinesText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Philippine IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Philippine proxies, you will undoubtedly enhance your proxy experience.",
  philippinesText2:
    "Carcal, Baybay, Bayawan, Tabuk, Gapan, Ligao, Lobo, Naga, Diablo, San Carlos, Tawako, Calapan, Oroquieta, Kababalan, Ma'ahsin, Masbate, Barangay, Kabalogan, Samar.",
  philippinesText3:
    'IPRocket offers residential proxies in the Philippines to fulfill a variety of needs. Business owners, marketers and developers can utilize these proxies for web crawling, ad verification, SEO monitoring, web testing, social media management, content management and other business applications.',
  philippinesText3_p2:
    'Schools, libraries and universities can use our agents to restrict access to specific websites and online content. Individual users can utilize them for a variety of purposes such as securely purchasing limited edition sneakers, online gaming, avoiding surveillance and accessing Singapore content platforms from abroad. ',
  philippinesText3_p3:
    'Whether you are a business owner, marketer, developer, web tester, organization administrator, parent, or just a regular internet user, our reliable Philippines proxies can greatly meet your needs!',
  philippinesText4:
    'Free Philippine proxies may limit your bandwidth and potentially leak your private data. These proxies are often obtained illegally and shared by multiple users at the same time, making them unsuitable for gaming, streaming, download seeding, web crawling, and other activities. ',
  philippinesText4_p2:
    'Some free proxies may even violate your online privacy by selling or sharing your personal or financial information with marketers or other third parties. For these reasons, we recommend avoiding free Philippines proxies and instead choosing reliable and premium proxies from trusted providers such as IPRocket. Our Filipino proxies come from legitimate sources, are completely anonymous, safe and secure.',
  philippinesWhyTitle1: 'One of the fastest Philippine. proxy service providers',
  philippinesWhyTitle2: 'Continuously scalable Philippine proxy pool',
  philippinesWhyTitle3: 'Easy integration with Philippine proxy servers',
  philippinesWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Philippine market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Philippine proxies are the ideal public web crawling tool.',
  philippinesWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  philippinesWhyText3:
    "We make sure that our Philippine proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Philippine proxies and make sure you don't have to deal with complicated integrations.",
  philippinesBtn: 'Get Philippine Proxy',

  canadaH1: 'Most Reliable Canadian Proxy',
  canadaH2T2: 'Canadian proxy Prices',
  canadaH2T3: "Why IPRocket's Canadian Proxy is the Best Choice?",
  canadaH2T4: 'Who should use a Canadian proxy',
  canadaH2T5: "Why shouldn't you use a free Canadian proxy?",
  canadaH2T6: 'Q & A',
  canadaH3: 'Proxy for the Canadian cantons',
  canadaText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Canadian IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Canadian proxies, you will undoubtedly enhance your proxy experience.",
  canadaText2:
    'Wellesley, Elliot Lake, Lumberton Shores, Nelson, Cantley, Williams Lake, Milford, Latook, Estevan, Norwich, Warman, North Saanich, Kincardine, Irene, Montmagny, South Huron.',
  canadaText3:
    'Our Canadian IP addresses offer a wide range of customization options to fit the needs of all types of users. Home users can enjoy a more unlimited Internet experience, bypass geographic restrictions, and potentially find cheaper travel deals. Proxies also enhance online privacy and protect users from unwanted attention. ',
  canadaText3_p2:
    "On the other hand, businesses utilize proxies for a variety of marketing strategies. From monitoring competitors and identifying popular products in their field to executing precise social media advertising campaigns, agents have revolutionized digital marketing. In today's digital landscape, the value of a reliable Canadian proxy server provider cannot be underestimated.",
  canadaText4:
    'There are two main reasons to avoid free proxy services. Firstly, they have weak security measures and usually leak user data. This compromised data can be used to infect devices, steal social media accounts, and even access bank details. Many stories detail successful Instagram influencers losing accounts and revenue due to inadequate digital identity protection.',
  canadaText4_p2:
    "Second, free Canadian proxies are usually slow. For campaigns like streaming or marketing, you need fast proxies. However, sharing a free proxy with many users can significantly slow down your connection. For these reasons, it would be wiser to choose IPRocket's secure and high-speed proxy service.",
  canadaWhyTitle1: 'One of the fastest Canadian. proxy service providers',
  canadaWhyTitle2: 'Continuously scalable Canadian proxy pool',
  canadaWhyTitle3: 'Easy integration with Canadian proxy servers',
  canadaWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Canadian market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Canadian proxies are the ideal public web crawling tool.',
  canadaWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  canadaWhyText3:
    "We make sure that our Canadian proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Canadian proxies and make sure you don't have to deal with complicated integrations.",
  canadaBtn: 'Get Canadian Proxy ',

  germanyH1: 'Most Reliable German Proxy',
  germanyH2T2: 'German proxy Prices',
  germanyH2T3: "Why IPRocket's German Proxy is the Best Choice?",
  germanyH2T4: 'Who should use a German proxy',
  germanyH2T5: "Why shouldn't you use a free German proxy?",
  germanyH2T6: 'Q & A',
  germanyH3: 'Proxy for the German cantons',
  germanyText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 German IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium German proxies, you will undoubtedly enhance your proxy experience.",
  germanyText2:
    'Waldkirchen, Riedlingen, Kuehlfurt, Gainesheim, Lichtenau, Nossen, Felsberg, Bleicherode, Deming, Bruinsbedrach, Gomeln, Ardötin, Teckelberg, Weilheim.',
  germanyText3:
    'For many users, a reliable German proxy service can offer a number of advantages. Businesses often utilize proxy services for market data crawling, social media campaign management, ad verification, SEO tracking, and other operational needs. Educational institutions such as schools and universities use proxies to control access to online content.',
  germanyText3_p2:
    'Home users are also satisfied by the fact that proxy services enhance online privacy and security, allowing them to enjoy a more open Internet experience. By hiding the original IP address behind a proxy server, it is much more difficult for individuals to be tracked online. In addition, switching IP addresses allows users to bypass geographic restrictions and access a wider range of online content',
  germanyText4:
    'There are several reasons to avoid using free proxy services in Germany. One major concern is the motivation behind offering free services. Typically, developers make profits by stealing user data. Free proxies may force web pages to load in HTTP, bypassing encryption and exposing your online activity. If cybercriminals set up a free proxy to monitor traffic, they can further exploit your data.',
  germanyText4_p2:
    'Another issue is the anonymity of the service provider. Often times, it is impossible to trace free proxy services back to real individuals because they usually hide their identities. Even if law enforcement gets involved, the likelihood of successfully resolving the issue is very low.',
  germanyWhyTitle1: 'One of the fastest German. proxy service providers',
  germanyWhyTitle2: 'Continuously expanding pool of German proxies',
  germanyWhyTitle3: 'Easy Integration of German Proxy Servers',
  germanyWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the German market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our German proxies are the ideal public web crawling tool.',
  germanyWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  germanyWhyText3:
    "We make sure that our German proxies integrate easily with third-party software, such as proxy IP address management tools for browsers. We have created tutorials in our blog for a hassle-free integration process. Get our German proxies and make sure you don't have to deal with complicated integrations.",
  germanyBtn: 'Get German Proxy ',

  japenH1: 'Most Reliable Japanese Proxy',
  japenH2T2: 'Japanese proxy Prices',
  japenH2T3: "Why IPRocket's Japanese Proxy is the Best Choice?",
  japenH2T4: 'Who should use a Japanese proxy',
  japenH2T5: "Why shouldn't you use a free Japanese proxy?",
  japenH2T6: 'Q & A',
  japenH3: 'Proxy for the Japanese cantons',
  japenText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Japanese IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Japanese proxies, you will undoubtedly enhance your proxy experience.",
  japenText2: 'Tokyo, Saka, Kanagawa Prefecture, Okinawa',
  japenText3:
    'Almost anyone planning a trip to Japan or conducting business can benefit from a Japanese IP address. Japan has a fast-growing information technology sector, a rich assortment of consumer products, and numerous investment opportunities. In addition, Japan offers a unique culture, globally recognized television programs, and extraordinary holiday experiences.',
  japenText3_p2:
    'If Japan is some distance away, the high-speed proxies provided by IPRocket will ensure that you get maximum speed for marketing campaigns or watching TV programs. You will also enjoy enhanced privacy protection, reducing the risk of unwanted attention to your online activities.',
  japenText4:
    "Free Japanese proxies have poor signaling. Japan is a technologically advanced country and their cybercriminals can utilize the latest technology to attack unsuspecting users. Free proxies may look appealing, but their developers need to make money somehow. They may sell your data to the highest bidder, and using free proxies also exposes you to the risk of losing your online credentials, which can lead to serious financial losses. To avoid unnecessary problems, it's best to rely on paid premium Japanese proxies. ",
  japenText4_p2:
    'Furthermore, paid proxies are much faster than free proxies, so if you want to watch Japanese content in high quality and smoothly, investing in a premium proxy service provided by IPRocket is crucial!',
  japenWhyTitle1: 'One of the fastest Japanese. proxy service providers',
  japenWhyTitle2: 'Continuously scalable Japanese proxy pool',
  japenWhyTitle3: 'Easy integration with Japanese proxy servers',
  japenWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Japanese market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Japanese proxies are the ideal public web crawling tool.',
  japenWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  japenWhyText3:
    "We make sure that our Japanese proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Japanese proxies and make sure you don't have to deal with complicated integrations.",
  japenBtn: 'Get Japanese Proxy ',

  vietnamH1: 'Most Reliable Vietnam Proxy',
  vietnamH2T2: 'Vietnam proxy Prices',
  vietnamH2T3: "Why IPRocket's Vietnam Proxy is the Best Choice?",
  vietnamH2T4: 'Who should use a Vietnam proxy',
  vietnamH2T5: "Why shouldn't you use a free Vietnam proxy?",
  vietnamH2T6: 'Q & A',
  vietnamH3: 'Proxy for the Vietnam cantons',
  vietnamText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Vietnam IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Vietnam proxies, you will undoubtedly enhance your proxy experience.",
  vietnamText2:
    '、Phu Quoc Giang, Hai Phong, Hanoi, Ho Chi Minh, En Nai, Thiep Phu, Tibet, Nam An, Bulong, Bac Ninh, Pek Kong',
  vietnamText3:
    'Cybersecurity experts recommend using proxies to enhance online privacy protection. For professional cybercriminals, tracking by IP address is usually relatively easy. If you are conducting business online, using a proxy server to hide your original IP address is a smart way to minimize unnecessary risk.',
  vietnamText3_p2:
    "Reliable proxy services offer many benefits for marketing operations. Users with Vietnam proxies can create and manage multiple social media accounts, bypass geo-restrictions, interact directly with consumers, verify ads, and more. This helps to increase investment opportunities and enable safer online business practices. Contact IPRocket today and we'll help you find the best proxy service solution for your needs.",
  vietnamText4:
    "Using free Vietnam proxies can cause more problems for several reasons. First of all, connection speed is crucial for proxy users and free proxies cannot guarantee this. Often, you'll be sharing the proxy server with other users, and if they're downloading large files or watching high-quality videos, your connection speed will be significantly reduced. This is especially problematic when grabbing competitors' data or comparing prices, as delays can cause you to miss important investment opportunities.",
  vietnamText4_p2:
    'Additionally, security is a major concern. Most free proxies lack strong security features, making them a prime target for cybercriminals. If you conduct online banking operations, it is vital that you avoid using free Vietnamese proxies to protect your sensitive information. Choosing a reliable service like IPRocket will provide you with the speed and security you need.',
  vietnamWhyTitle1: 'One of the fastest Vietnam. proxy service providers',
  vietnamWhyTitle2: 'Continuously scalable Vietnam proxy pool',
  vietnamWhyTitle3: 'Easy integration with Vietnam proxy servers',
  vietnamWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Vietnam market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Vietnam proxies are the ideal public web crawling tool.',
  vietnamWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  vietnamWhyText3:
    "We make sure that our Vietnam proxies integrate easily with third-party software, such as a browser's proxy IP address management tool. We have created tutorials in our blog for a hassle-free integration process. Get our Vietnam proxies and make sure you don't have to deal with complicated integrations.",
  vietnamBtn: 'Get Vietnam Proxy ',

  brazilH1: 'Most Reliable Braizil Proxy',
  brazilH2T2: 'Braizil proxy Prices',
  brazilH2T3: "Why IPRocket's Braizil Proxy is the Best Choice?",
  brazilH2T4: 'Who should use a Braizil proxy',
  brazilH2T5: "Why shouldn't you use a free Braizil proxy?",
  brazilH2T6: 'Q & A',
  brazilH3: 'Proxy for the Braizil cantons',
  brazilText1:
    "Our proxies have an impressive 99.86% stable uptime. Currently, our proxy pool contains 1,129,487 Braizil IP addresses, and this number is constantly growing, ensuring that you will never run out of options. With IPRocket's premium Braizil proxies, you will undoubtedly enhance your proxy experience.",
  brazilText2:
    'Barceluche, Altinopolis, Oliveira, Winfo, Pintorama, Santa Adelia, Tupipolista, Itajopi, Badibaste, Pedreguliu, Šalkiada, Eldorado, Britama.',
  brazilText3:
    "Brazil's vast territory ensures that proxy services can benefit all types of users in many ways. For example, using a Brazilian IP address can help you get cheaper airfare or hotel rates. When you travel to Brazil, connecting to our private proxy servers can hide your IP address and encrypt your data, providing extra security against potential cyberattacks.",
  brazilText3_p2:
    'Business owners can utilize proxies to monitor SEO trends, crawl Brazilian online market data, manage multiple social media accounts, prevent fraud, and verify campaign effectiveness. Each approach offers different benefits for a variety of operations, depending on your business needs.',
  brazilText4:
    'Free proxies are never a good option, especially not when considering Brazil, one of the four countries most affected by ransomware attacks in 2021. It is vital to remain vigilant if conducting business there, as ransomware gangs often target unprotected online businesses, encrypting their data and demanding high ransoms, which can seriously affect growing businesses.',
  brazilText4_p2:
    'Free proxies usually lack adequate cybersecurity measures and are therefore often targeted by cybercriminals. Choosing a reputable paid proxy service provider like IPRocket ensures additional cybersecurity features to protect your data. Our proxy servers are designed to prevent confidential information from being leaked online, providing peace of mind for your online activities.',
  brazilWhyTitle1: 'One of the fastest Braizil. proxy service providers',
  brazilWhyTitle2: 'Continuously expanding pool of Brazilian proxies',
  brazilWhyTitle3: 'Easy Integration of Brazilian Proxy Servers',
  brazilWhyText1:
    'we are proud of the high-speed proxies that IPRocket offers in the Braizil market. With up to 99.86% availability, these proxies guarantee fast and stable connections and greatly reduce the risk of IP blocking. No matter how large your data collection needs are, our Braizil proxies are the ideal public web crawling tool.',
  brazilWhyText2:
    'IPRocket places great emphasis on developing resources to meet the most demanding business needs. We continue to expand and optimize our pool of residential proxies to ensure that we are able to provide a high quality and reliable service. In addition to increasing the number of proxies, we are constantly upgrading and expanding various proxy types, such as Socks5 and HTTP(s), to meet the specific needs and application scenarios of different customers.',
  brazilWhyText3:
    "We make sure that our Brazilian proxies integrate easily with third-party software such as proxy IP address management tools for browsers. We have created tutorials in our blog for a hassle-free integration process. Get our Brazilian proxies and make sure you don't have to deal with complicated integrations.",
  brazilBtn: 'Get Braizil Proxy ',

  moreH2T1: 'Why choose IPRocket as your proxy?',
  moreH2T2: 'All the countries',
  moreText1:
    'When you use a proxy, your real IP address is replaced with a new IP address of your choice, enabling a completely anonymous Internet access experience.IPRocket provides high-speed residential proxies that ensure more than 99.86% stable uptime, providing you with industry-leading speed, stability, security and personalized service. ',
  moreText1_1:
    "We specialize in providing customized solutions for business and individual users to meet the needs of various usage scenarios. You can select a specific continent, region or even city to ensure that the proxy service is exactly what you expect. With just a few clicks, you can easily set up and manage your brand new proxies on our dashboard page. Whether you need to perform data crawling, market analysis in different regions of the world, or wish to unlock websites and services in a specific region, IPRocket's proxy service provides you with superior performance and security. Let us help you realize the security and freedom of your online activities!",
  moreText1_2:
    "When you use a proxy, your real IP address is replaced with a new IP address of your choice, enabling a completely anonymous Internet access experience.IPRocket provides high-speed residential proxies that ensure more than 99.86% stable uptime, providing you with industry-leading speed, stability, security and personalized service. We specialize in providing customized solutions for business and individual users to meet the needs of various usage scenarios. You can select a specific continent, region or even city to ensure that the proxy service is exactly what you expect. With just a few clicks, you can easily set up and manage your brand new proxies on our dashboard page. Whether you need to perform data crawling, market analysis in different regions of the world, or wish to unlock websites and services in a specific region, IPRocket's proxy service provides you with superior performance and security. Let us help you realize the security and freedom of your online activities!",
  moreText2:
    "Cybersecurity experts recommend using proxies to enhance online privacy protection. For professional cybercriminals, tracking by IP address is usually relatively easy. If you are conducting business online, using a proxy server to hide your original IP address is a smart way to minimize unnecessary risk. Reliable proxy services offer many benefits for marketing operations. Users with Vietnam proxies can create and manage multiple social media accounts, bypass geo-restrictions, interact directly with consumers, verify ads, and more. This helps to increase investment opportunities and enable safer online business practices. Contact IPRocket today and we'll help you find the best proxy service solution for your needs.",
  Aisa: 'Asia',
  Europe: 'Europe',
  NorthAmerica: 'North America',
  SouthAmerica: 'South America',
  Oceania: 'Oceania',

  Bhutan: 'Bhutan',
  TimorLeste: 'Timor-Leste',
  China: 'China',
  Uzbekistan: 'Uzbekistan',
  Yemen: 'Yemen',
  Armenia: 'Armenia',
  Israel: 'Israel',
  Iraq: 'Iraq',
  Ira: 'Ira',
  Qatar: 'Qatar',
  Indonesia: 'Indonesia',
  India: 'India',
  Syria: 'Syria',
  Kyrgyzstan: 'Kyrgyzstan',
  Kazakhstan: 'Kazakhstan',
  Shikumenstein: 'Shikumenstein',
  Tajikistan: 'Tajikistan',
  Bangladesh: 'Bangladesh',
  Nepal: 'Nepal',
  Pakistan: 'Pakistan',
  Palestine: 'Palestine',
  Brunei: 'Brunei',
  SriLanka: 'SriLanka',
  Singapore: 'Singapore',
  Japan: 'Japan',
  Cambodia: 'Cambodia',
  SaudiArabia: 'SaudiArabia',
  Thailand: 'Thailand',
  Theturkey: 'Theturkey',
  Kuwait: 'Kuwait',
  Jordan: 'Jordan',
  Myanmar: 'Myanmar',
  Laos: 'Laos',
  Lebanon: 'Lebanon',
  Philippines: 'Philippines',
  Mongolia: 'Mongolia',
  Vietna: 'Vietna',
  Azerbaijan: 'Azerbaijan',
  Afghanistan: 'Afghanistan',
  Oman: 'Oman',
  TheUnitedArabEmirates: 'United Arab Emirates',
  SouthKorea: 'South Korea',
  Maldives: 'Maldives',
  Malaysia: 'Malaysia',

  Denmark: 'Denmark',
  Ukraine: 'Ukraine',
  Russia: 'Russia',
  Bulgaria: 'Bulgaria',
  Croatia: 'Croatia',
  Iceland: 'Iceland',
  Liechtenstein: 'Liechtenstein',
  Hungary: 'Hungary',
  NorthernCyprus: 'NorthernCyprus',
  Luxembourg: 'Luxembourg',
  SanMarino: 'SanMarino',
  Serbia: 'Serbia',
  Cyprus: 'Cyprus',
  Austria: 'Austria',
  Andorra: 'Andorra',
  Greece: 'Greece',
  Italy: 'Italy',
  Latvia: 'Latvia',
  Norway: 'Norway',
  TheCzechRepublic: 'TheCzechRepublic  ',
  Moldova: 'Moldova',
  Monaco: 'Monaco',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Belgium: 'Belgium',
  Poland: 'Poland',
  BosniaAndHerzegovina: 'Bosnia and Herzegovina',
  Ireland: 'Ireland',
  Estonia: 'Estonia',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Belarus: 'Belarus',
  Gibraltar: 'Gibraltar',
  Kosovo: 'Kosovo',
  Lithuania: 'Lithuania',
  Romania: 'Romania',
  Finland: 'Finland',
  TheNetherlands: 'Netherlands',
  Portugal: 'Portugal',
  Monteneglo: 'Monteneglo',
  Spain: 'Spain',
  Albania: 'Albania',
  Macedonia: 'Macedonia',
  Malta: 'Malta',

  Belize: 'Belize',
  Guatemala: 'Guatemala',
  Cuba: 'Cuba',
  DominicanRepublic: 'Dominica',
  Nicaragua: 'Nicaragua',
  TheBahamas: 'TheBahamas',
  Panama: 'Panama',
  Greenland: 'Greenland',
  PuertoRico: 'Puerto Rico',
  Honduras: 'Honduras',
  Haiti: 'Haiti',
  Jamaica: 'Jamaica',
  TrinidadAndTobago: 'Trinidad and Tobago',
  Bermuda: 'Bermuda',
  ElSalvador: 'El Salvador',
  Mexico: 'Mexico',

  Uruguay: 'Uruguay',
  Ecuador: 'Ecuador',
  Colombia: 'Colombia',
  Guyana: 'Guyana',
  Venezuela: 'Venezuela',
  Paraguay: 'Paraguay',
  Chile: 'Chile',
  FrenchGuiana: 'French Guiana',
  Bolivia: 'Bolivia',
  FalklandIslands: 'Falkland Islands',
  Peru: 'Peru',
  Suriname: 'Suriname',
  Argentina: 'Argentina',

  PapuaNewGuinea: 'Papua New Guinea',
  SolomonIslands: 'Solomon Islands',
  Fiji: 'Fiji',
  NewCaledonia: 'New Caledonia',
  NewZealand: 'New Zealand',
  Australia: 'Australia',
  Vanuatu: 'Vanuatu',

  aboutUSH1: 'IPRocket Proxy',
  aboutUSText1:
    "Since its inception, IPRocket has grown rapidly, from a handful of individuals to a large and dynamic international team. With transparent operations, reliable solutions, and a fully customizable pricing strategy, we've quickly earned a reputation for serving Fortune 500 companies, self-employed individuals, and everyone in between. At IPRocket, we believe that online information should be accessible to everyone - whether they are businesses, data scientists, developers, marketers, or other users in need. We are committed to making data accessible to everyone through innovative services, superior price/performance ratios, and an outstanding customer experience.",
  contactUSH1: 'Contact IPRocket',
  contactUSText1:
    'If you have any questions, please feel free to contact us through our feedback form or any other convenient means of communication. Our managers are online 24/7 and are always available to help you and solve any problems you may have.',
  developmentH2: 'Development History',
  '': '',
  whatProxy:
    'A proxy is a way to connect a device to the Internet, using its own IP address as an intermediary. It processes your requests, hides your real IP, and provides various features as needed to ensure privacy and security.',
  isWorking:
    'You can send a request to https://db-ip.com/ and the result will tell you the detailed IP address, IP location, and the service provider the IP belongs to. If the result matches the country/region you selected, it means the proxy is working properly. If the proxy does not work, please ask our customer service for help.',
  whatHouseProxy:
    "Residential proxies are assigned to a user's device using a unique IP address assigned to the device by an Internet Service Provider (ISP), thereby hiding the user's true IP address and physical location information. This service is particularly suitable for situations where anonymity needs to be maintained. By using residential proxies, users are able to perform a variety of activities on the Internet without exposing their personal information, protecting privacy and security, and is therefore important in terms of network security and data privacy.",
  Start: 'Start',

  statisticsH1: 'Statistics that we can be proud of',
  statistics1Number: '7,600+',
  statistics1Explain: 'Total number of global customers',
  statistics2Number: '300+',
  statistics2Explain: 'Number of integrations with tools or software',
  statistics3Number: '120+',
  statistics3Explain: 'The number of team members is increasing every week',
  statistics4Number: '100,000TB+',
  statistics4Explain: 'Traffic provided to clients',

  Telegram: 'Telegram',
  Skype: 'Skype',
  Whatsapp: 'Whatsapp',
  Wechat: 'Wechat',

  partenrsH1: 'Our Partners',
  partenrtText1:
    'IPRocket is a professional proxy resource service provider with IP resources covering more than 210 countries around the world. Become an IPRocket partner and you will get more website exposure and user browsing. Apply to be our professional partner, you can help your users get more discounts.',
  partenrtTip1: 'Global Pools',
  partenrtTip2: '80M+ High-Quality IPs',
  partenrtTip3: 'Best Residential Proxy Services',
  newBuy: 'Buy Now',
  //----------------------------------------
  homeH1: 'High-quality residential proxy, fast and stable！',
  homeReviewP1:
    "I've been using IPRocket's residential IPs for web scraping, and I've been impressed with the level of service they provide.The IPs are clean, which is essential for maintaining anonymity and avoiding bans!",
  homeReviewP2:
    'IPRocket exceeded my expectations in terms of data collection. Their rotating residential proxys were instrumental in gathering market information for our research project.',
  homeReviewP3:
    'Their Application Programming Interface (API) integration allows them to fit seamlessly into our existing workflow.If you need a reliable proxy service for web search or data mining, IPRocket is the right choice!',
  homeQuestionP1: 'Can I try your residential proxy server?',
  homeAwensP1:
    'Of course, every new user has a 1G traffic trial package.The price is $1.99 and the trial will be activated once you select and pay for the correct tariff.',
  homeQuestionP2: 'What is the total number of IPs available on the network?',
  homeAwensP2:
    'Our proxies has more than 80 million IPs and covers more than 210 countries and territories.This number continues to grow.',
  homeQuestionP3: 'Why is IPRocket faster than other proxy servers?',
  homeAwensP3:
    "IPRocket's proxy service utilizes our optimized proxy network and traffic redirection technology.We deploy this network on super-proxy servers through hundreds of associated Internet Service Providers (ISPs) and Internet nodes worldwide. In this way, a user's proxy requests are quickly redirected to the nearest IP address, resulting in ultra-fast speeds and extremely stable network access.",
  homeQuestionP4: 'Is it legal to use a residential IP address? ',
  homeAwensP4:
    'It is generally legal to use a residential IP address, including through a residential proxy. Residential IP addresses are assigned to homeowners by Internet Service Providers (ISPs) for their personal use of the Internet. However, how you use a residential IP address or residential proxy server may require legal considerations depending on the specific activity you are engaged in.',
  homeQuestionP5: 'What are the payment options for residential proxies？ ',
  homeAwensP5: 'We accept credit/debit cards, PayPal, cryptocurrencies, bank transfers, paypal. ',
  homeQuestionP6: 'What is residential proxies? ',
  homeAwensP6:
    'Residential proxies are IP addresses assigned to homeowners by Internet Service Providers (ISPs). They essentially act as an intermediary between you and the Internet. When using a residential proxy, your web requests are routed through these residential IP addresses, making it appear that your browsing activity is coming from your home rather than a data center or server.The IPRocket proxy server network consists of IP addresses in over 210 countries worldwide. These proxies are commonly used for a variety of purposes, including web searching, data mining, market research, and bypassing geographic restrictions. These proxies are often considered more reliable and legitimate than other types of proxies because they can mimic the behavior of real users. However, they can be more expensive than other types of proxy servers due to their scarcity and maintenance costs.',
  PreciseTarget: 'Precise targeting, no hidden costs',

  MyBase: 'Compliance is the foundation of our business',
  MyService:
    'We take great care to ensure that our services are compliant with the GDPR, the CCPA, and other data-related legislation around the world. IPRocket is also a founding member of the Ethical Cyber Data Collection Initiative, which is dedicated to creating global best practices and advancing the development of global compliance practices for the industry by regulators.',

  questionTitle: 'Q & A',
  questionHomet1: 'Can I try your residential proxy server?',
  questionHomet2: 'What is the total number of IPs available on the network?',
  questionHomet3: 'Why is IPRocket faster than other proxy servers?',
  questionHomet4: 'Is it legal to use a residential IP address? ',
  questionHomet5: 'What are the payment options for residential proxies？ ',
  questionHomet6: 'What is residential proxies? ',
  questionAnswert1:
    'Of course, every new user has a 1G traffic trial package.The price is $1.99 and the trial will be activated once you select and pay for the correct tariff.',
  questionAnswert2:
    'Our Residential Proxies have over 60 million IPs, and our Premium Residential Proxies have over 90 million IPs. You can choose the plan that suits your needs.',
  questionAnswert3:
    "IPRocket's proxy service utilizes our optimized proxy network and traffic redirection technology.We deploy this network on super-proxy servers through hundreds of associated Internet Service Providers (ISPs) and Internet nodes worldwide. In this way, a user's proxy requests are quickly redirected to the nearest IP address, resulting in ultra-fast speeds and extremely stable network access.",
  questionAnswert4:
    'It is generally legal to use a residential IP address, including through a residential proxy. Residential IP addresses are assigned to homeowners by Internet Service Providers (ISPs) for their personal use of the Internet. However, how you use a residential IP address or residential proxy server may require legal considerations depending on the specific activity you are engaged in.',
  questionAnswert5: 'We accept credit/debit cards, PayPal, cryptocurrencies, bank transfers, paypal. ',
  questionAnswert6:
    'Residential proxies are IP addresses assigned to homeowners by Internet Service Providers (ISPs). They essentially act as an intermediary between you and the Internet. When using a residential proxy, your web requests are routed through these residential IP addresses, making it appear that your browsing activity is coming from your home rather than a data center or server.The IPRocket proxy server network consists of IP addresses in over 210 countries worldwide. These proxies are commonly used for a variety of purposes, including web searching, data mining, market research, and bypassing geographic restrictions. These proxies are often considered more reliable and legitimate than other types of proxies because they can mimic the behavior of real users. However, they can be more expensive than other types of proxy servers due to their scarcity and maintenance costs.',

    thanks: 'Due to the policy of the service area, this service is temporarily unavailable in Chinese Mainland. Please understand.',
    pay_thanks:'(This service is not available in Mainland China)',
  productFiveT1:
    'Experience unlimited access to our network of residential proxies covering over 210 countries. Bypass geographic restrictions with a large, stable network of residential proxies, powered by proprietary solutions.',

  getAmericaProxy: 'How do I get a US proxy?',
  getBrazilProxy: 'How do I get a Brazil proxy?',
  getBritainProxy: 'How do I get a UK proxy?',
  getCanadaProxy: 'How do I get a Canada proxy?',
  getGemanyProxy: 'How do I get a Gemany proxy?',
  getHongkongProxy: 'How do I get a HongKong proxy?',
  getJapanProxy: 'How do I get a Japan proxy?',
  getPhilippinesProxy: 'How do I get a Philippines proxy?',
  getVietnamProxy: 'How do I get a Vietnam proxy?',

  USAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the United States for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the U.S. proxy!',
  BrazilAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Brazil for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Brazil proxy!',
  BritainAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the UK for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the British proxy!',
  CanadaAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Canada for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Canadian proxy!',
  GermanyAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Germany for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the German proxy!',
  HonekongAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Hong Kong for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Hong Kong proxy!',
  JapanAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Japan for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Japanese proxy!',
  PholippinesAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Philippine for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Philippine proxy!',
  VietnaAnswert2:
    'After purchasing a residential proxy in IPRocket, jump to the Get Proxy interface, choose the Vietnam for the country, the state and city can be filled in according to the demand (no demand means blank), then choose the network type (socks5 or http(s)), then choose the rotation mode or sticky mode, and finally click on Generate, and then copy the generated url to your code or browser and you can use the Vietnam proxy!',

  recommendT1: 'IPRocket Referral Program',
  recommendT2: "Each new person can earn up to 10% of the commission funds you help to IPRocket's customers!",
  recommendT3: 'Register',
  recommendT4: 'Login',
  recommendT5: 'Industry-leading commissions',
  recommendT6: "IPRocket's affiliate program can earn you up to 10% commission.",
  recommendT7: 'Permanent profit',
  recommendT8: 'Profit from every order associated with the registered users you refer!',
  recommendT9: 'Profit from every order associated with the registered users you refer!',
  recommendT10:
    'More than 80 million residential proxy IPs, covering more than 210 countries and regions around the world, with a connection success rate as high as 99.86%.',
  recommendT11: '7/24 Technical Support',
  recommendT12: 'Professional technical team 7/24 to provide you with a full range of services.',
  recommendT13: 'How does it work?',
  recommendT14: "Submit your application and join IPRocket's Affiliate Partner System!",
  recommendT15:
    'When you join IPRocket, you will receive a 3% share of the base commission, which increases as purchase orders from invited users accumulate up to a certain amount, up to a maximum of 10%. The more money you accumulate, the more you get paid, there is no upper limit.',
  recommendT16: 'How do I invite someone else?',
  recommendT17: 'Become a part of 7600+  affiliate network',

  recommendStep: 'Step',
  recommendRegiter: 'Prepare to register',
  recommendShare: 'Share',
  recommendMnney: 'Earn money',

  recommendText1: 'Register or log in to IPRrocket',
  recommendText2:
    'Get the promotion link and invitation code and share IPRrocket agent solutions on your website or social media with your audience',
  recommendText3: 'After the invited user completes the registration and purchase, you can receive the commission',
  recommendText4: 'The invitee enters the website through your invitation link and completes the registration',
  recommendText5: 'The invitee enters your invitation code when registering and completes the registration',

  commentName1: 'Cleveland',
  commentName2: 'Delphia Jocelyn-',
  commentName3: 'Kerrie Cathryn',
  commentPos1: '-Chief Technology Officer',
  commentPos2: '-WM Corporation',
  commentPos3: '-Technical Director',
  commentCt1:
    "I've been using IPRocket's residential IPs for web scraping, and I've been impressed with the level of service they provide.The IPs are clean, which is essential for maintaining anonymity and avoiding bans!",
  commentCt2:
    'IPRocket exceeded my expectations in terms of data collection. Their rotating residential proxys were instrumental in gathering market information for our research project.',
  commentCt3:
    'Their Application Programming Interface (API) integration allows them to fit seamlessly into our existing workflow.If you need a reliable proxy service for web search or data mining, IPRocket is the right choice!',

  contactyousName: 'Your Name',
  contactyousEmail: 'Your e-mail',
  contactyousPhone: 'Your Phone',
  contactyousUrl: 'Url',
  contactyousType: 'Cause/Category',
  contactderide: 'Description',
  contactpuloadImg: 'Upload a picture',
  contactText1: 'Payment Voucher Notes： ·Format: jpg, jpeg or png.file ·Size: Maximum 20MB',
  contactfile: 'Attachment ',
  contactpointUpImg: 'Click to upload a file',
  contactonlyPDF: 'Only PDF files can be submitted, and the size cannot exceed 500K.',
  contactclickSub: "Click “Submit”.You agree to IPRocket's Privacy Policy.",
  contactSubmit: 'Submit',
  '': '',
  center: 'Dashboard',
  clear: 'Sign Out',
  hotLocationTitle: 'Most popular locations',

  aboutYear1: '2019',
  aboutT1: 'IPRocket is founded',
  aboutText1:
    'IPRocket appears on the market to enable organizations to enhance their data collection practices and gain top-notch web agent insights.',

  aboutYear2: '2021',
  aboutT2: 'Corporate AI technology',
  aboutText2:
    'Industry-leading machine learning models enable our data collection solutions to automatically adapt to changes in website layout.',

  aboutYear3: '2022',
  aboutT3: 'Release of Web Unblocker',
  aboutText3:
    'IPRocket renames Next-Gen Residential Proxies to Web Unblocker: an AI-powered, non-blocking scraping solution.',

  aboutYear4: '2024',
  aboutT4: 'Proxy pool reaches 80M+ IPs',
  aboutText4:
    "IPRocket acquires the world's third-largest pool of ethical and compliant combined proxies, delivering over 80M IPs globally.",
  proxy: 'Proxy',
  getPrice: 'Price',

  AntiBrowser: ' Anti-detection Browser',
  Navigation: 'E-commerce Navigation',
  Inspection: 'IP Inspection',
  bigData: 'Cloud Mobile & Big Data',
  Payment: 'Payment & More',
  partnershipTitle: 'Cooperate with us',

  centerNav_t1: 'Balance:',
  centerNav_t2: 'Remaining enterprise traffic',
  centerNav_t3: 'Remaining personal traffic',
  centerNav_t4: 'Expires in',
  centerNav_t5: 'Profile',
  centerNav_t6: 'Log out',

  tabTitle: 'Residential Proxy',
  tabTitle2: 'Premium Residential Proxy',
  tabTitle2_1: 'Premium',
    tabTitle2_2:'Residential Proxy',
  supHouse: 'Premium Residential Proxy',
  supText: 'Over 90 million real IPs, supporting HTTP(s) and Socks5.',
  supHouseDes: 'Premium Residential Proxies: Cleaner IP Pool, Faster Speeds',
  SupProductText:
    'Compared to standard residential proxies, premium residential proxies ensure higher anonymity and security for users performing tasks such as data scraping, market research, and account management. This proxy service not only effectively avoids IP bans and restrictions but also ensures successful requests with smart IP rotation. It is suitable for various fields, including e-commerce, social media management, and web scraping.',
  supAdv1: 'Targeting at country, state/province, and city levels',
  supAdv2: 'Over 90 million real IPs',
  supAdv3: 'No concurrent session limits',
  supAdv4: 'No bandwidth restrictions',
  supAdv5: '24/7 technical support',

  supFunTitle1: 'No Contract Required',
  supFunDes1: 'You can start using our residential proxies without signing any complex contracts or commitments.',
  supFunTitle2: 'Unlimited Sessions',
  supFunDes2: 'We place no limits on the number of concurrent sessions—use as many as you need.',
  supFunTitle3: 'Accessibility',
  supFunDes3: 'Our residential proxies can be used on any website, as we have no access restrictions.',
  supFunTitle4: 'Automatic Rotation',
  supFunDes4: 'Automatically replace your residential proxy IPs by setting intervals in seconds, minutes, or hours.',
  supFunTitle5: 'Manual IP Change',
  supFunDes5: 'Switch your residential proxy IP address with a single click on the dashboard or via an API request.',
  supFunTitle6: 'Never Get Blocked',
  supFunDes6: 'IP blocks are no match for our residential proxy network, as you can change IPs at any time.',

  supPop: 'Premium Residential Proxies Loved by Major Companies',
  supPopDes:
    "By combining our proprietary algorithms with IPRocket's advanced residential proxies, we have not only revolutionized how our proxy network connects but also significantly enhanced our web crawling capabilities. Most importantly, this gives us a cost advantage.",

  supReason: "Why Should You Use IPRocket's Premium Residential Proxies?",
  supReason1: 'Precise Geo-Location Targeting',
  supReasonDes1:
    'Our residential proxy network spans 210 countries/regions, offering continent, country/region, state, city, and ASN (ISP) targeting. IPRocket proxies help access geo-restricted content with no hidden fees.',
  supReason2: 'Unlimited Concurrent Sessions',
  supReasonDes2:
    'While other proxy services may charge extra for additional concurrent sessions, at IPRocket, we place no limits on concurrent sessions, allowing you to easily scale your web scraping projects at any time.',
  supReason3: 'Single Backconnect Entry',
  supReasonDes3:
    'A single backconnect proxy gives you access to a continuously rotating proxy pool, enabling you to control sessions and avoid IP bans and CAPTCHAs. In return, your scraping projects can guarantee an average success rate of 99.86%.',

  supRe1: 'Massive Residential IP Proxy Pool',
  supReDes1: 'We provide the most stable residential proxy IP pool with over 90M+ IPs available for your use.',
  supRe2: 'Zero CAPTCHAs',
  supReDes2: 'Optimize your business resources with no need to handle CAPTCHAs.',
  supRe3: 'Zero IP Blocks',
  supReDes3: 'No more wasting time on IP blocks—purchase residential IPs and focus on gathering market insights.',
  supRe4: 'Session Control',
  supReDes4:
    'Residential proxies from IPRocket come with both rotating and sticky session control features to meet all your business needs.',
  supRe5: 'Unlimited Bandwidth and Concurrent Sessions',
  supReDes5: 'No bandwidth or concurrency limitations—purchase residential IPs and send unlimited concurrent sessions.',
  supRe6: 'Global Coverage',
  supReDes6:
    'Purchase residential IPs with coverage in 210 locations, offering continent, country, state, city, and ASN targeting.',

  supAd: 'Patented Solutions',
  supAdDes:
    'Our residential proxy network uses patented technology and the most advanced transport layer network protocols. Cutting-edge technology enhances the speed, reliability, and security of our network, providing users with a seamless, uninterrupted scraping experience. We bypass geo-restrictions using the largest and most stable residential proxy network, powered by patented solutions.',
  buyPlan: 'Purchase Plan',
  totalNum: 'Total Traffic',
  supPerPlan: 'Premium Personal Plan',
  supEnPlan: 'Premium Enterprise Plan',
  exchangeSuccess: 'success',
  addProxyAccounts: 'Add',
  saveMoney: 'Save 72%',
  startWith: 'Start at',
  lastTime: '1-60 minutes sticky session',
  lastTime2: '1-60 minutes sticky session',
  autoChange: 'Automatic proxy rotation',
  buyGoods: 'Purchase a plan',
  buyNeed: 'Purchase the ',
  goodsType: 'Plan ',
  goodsType1: 'you need',
  addProxy: 'Add Proxy Account',
  addD: 'Add ',
  proxyAccount: 'Proxy Account',
  whiteName: 'Whitelist',
  getProxy: 'Extract proxies ',

  selectTitle: 'Choose ',
  andTitle: ' or ',
  getProxys: ' accessaccess to obtain proxies',
  priceTitle: 'Premium Residential Proxies Price',
  priceTitle2: 'Residential Proxies Price',
  notUse: 'Inactive Traffic',
    howToUse: 'View History Details',
    Detailed: 'Personal Plan Activation Records',
    DynamicResidence:'Dynamic Residence',
  buyed: 'Purchased Traffic(GB)',
  cityAll: 'ALL',
  ipError: 'Failed to obtain IP address',
  currentIP: 'Current IP:',
  notList: 'not yet added to the whitelist, please add before generating.',
  noFlow: 'The current data usage is 0, please purchase a package.',
  warning: 'Warning',
  copyText: 'Replicating Success',
  copyError: 'Please generate data first',
  noMoney: 'Insufficient commission',
  email_error: 'Please enter the correct email address',
  passwordType:
    'Please enter a 15-character password composed of numbers and uppercase/lowercase letters.',
  New:'Over 210 locations worldwide',
  New2:'Automatic Proxy Rotation',
  New3:'Average response time of 0.5 seconds',
  New4:'Over 60 million HTTP(S) and SOCKS5 IPs',
  New5:'Average success rate of 99.95%',
  New6:'Maintain optimal download speed',
  New7:'Achieve higher anonymity using IP addresses from real users. Access a broader proxy pool and reduce blocks caused by websites anti-crawling measures.',
  New8:'Starting price',
  New9:'Residential proxies are ideal for products and services that require continuous monitoring and observation of market price trends.',
  New10:'Network marketing',
  New11:'Leverage the potential of residential proxies to expand your market reach and maximize your marketing impact.',
  New12:'One of the most common applications of residential proxies is to monitor and verify the advertisements displayed on your pages.',
  New13:'Web scraping',
  New14:'Web scraping allows you to collect up-to-date information that is crucial for your business decisions.',
  New15:'Started Guide',
  New16:'Tutorial Documentation',
  New17:'Frequently Questions',
  New18:'Quick Start',
  New19:'Endpoint Generator',
  New20:'Statistics',
  New21:'New Customer Offer',
  New22:'Most Popular',
  New23:'Total price',
  New24:'Regular',
  New25:'Company',
  New26:'Features',
  New27:'Extremely high stability with an uptime of 99.7%',
  New28:'Prices start as low as $0.65/GB.',
  New29:'Over 60 million residential IPs from ethical sources',
  New30:'An average success rate of 99.82%',
  New31:'An average response time of 0.41 seconds',
  New32:'Country / State / City / Target Positioning',
  New33:'Seize Your First Order Offer',
  New34:'Authentication Method.',
  New35:'Select the account identity authentication method. Please select your proxy user account and password. If you choose the whitelist IP method, we will automatically obtain the whitelist proxy you have added.',
    sele1:"general",
    sele2:"Asia",
    sele3:"Europe",
    sele4:"America",
    sele5:"Microsoft",
    sele6:"National Line",
    sele7:"Regional Line",
    sele7_1:"Operator dedicated line",
    sele8:"IPv4 Proxy",
    sele9:"IPv6 Proxy",
    sele10:"ISP Proxy",
  New36:'Unparalleled speed and reliability for complete scraping freedom.',
  New37:'Pay-as-you-go',
  New38:'Learn More',
  New39:'CDK Redemption',
  New40:'Start',
  New41:'Learn about integrating your residential proxies into storage.',
  New42:'Obtain Help',
  New43:'Do you need help choosing the right products for your business?',
  New44:'The package only costs',
  New45:'Start saving money now',
  New46:'position setting',
  New47:'List of countries',
  New48:'Choose a precise proxy location or leave "Any" for a random proxy location.',
  New49:'Session Settings',
  New50:'Using a sticky session allows the same IP to be retained for up to 60 minutes; selecting a rotating session enables obtaining a new IP for each request.',
  New51:'Add proxy account.',
  New52:'Add Now',
  New53:'Affiliate',
  New54:'Account',
  New55:'The start time cannot be greater than the end time.',
  New56:'CDKEY Management',
  New57:'Generate Details',
  New58:'Redemption Details',
  New59:'recharge',
  New60:'Remaining Available Capacity',
  New61:'Starting from 2GB',
  New61_2:'Starting from 100GB',
  New62:'Exchange',
  New63:'CDKEY Usage Tutorial',
  New64:'Step 1',
  New65:'Step 2',
  New66:'Step 3',
  New67:'Step 4',
  New68:'Step 5',
  New69:'Enter the amount of data/GB you want to generate, starting from 2GB.',
  New70:'Enter the number of CDKEYs to generate.',
  New71:'Click the [generate] button.',
  New72:'Copy the generated CDKEY and send it to other users.',
  New73:'Other users can copy the CDKEY you sent, go to the dashboard in their personal accounts, and redeem the CDKEY there.',
  myAccount: 'My Account',
  myProfile: 'Overview of Account Information',
  personalInfo: 'Personal Info',
  accountName: 'Account Name',
  accountVerified: 'The account has been registered and verified with real name authentication',
  accountID: 'Account ID',
  emailName: 'Email Address', 
  password: 'Password',
  
  joinDays: 'Join Days',
  strong_password_tip: 'A strong password makes your account more secure. It is recommended that you change your password regularly.',
  immediately_modify: 'Modify Immediately',
  basicInfo: 'Basic Information', 
  givenName: 'Given Name', 
  familyName: 'Family Name', 
  country: 'Country',
  otherAccountInfo: 'Other Account Information',
  createTime: 'Creation Time',
  manageAccount: 'Manage Account',
  deleteAccount: 'Delete Account',
  save: 'Save',
  New74: 'Export',
  New75: 'Please enter 1, 2, or a multiple of 10',
  New75_1:'Generated traffic/GB',
  New75_2:'Number of traffic generation shares',
  New75_3:'Currently, there is no permission to generate CDK. Please contact customer service to activate it',
  New76:'Creation Date',
  New77:'Traffic',
  New78:'Each time an invited user makes a successful payment, you will receive 3% of the revenue.',
  New79:'Bidding on the Thordata trademark in paid search ads is prohibited, We reserve the right to suspend any account that violates this rule.',
  New80:'If your invited user cancels their subscription or requests a refund during the commission period, the corresponding commission reward will be cancelled immediately.',
  New81:'Affiliate Program',
  New82:'Invitation Details',
  New83:'Redemption Details',
  New84:'Reward Details',
  New85:'Username',
  New86:'Reward Balance',
  New87:'Total Rewards',
  New88:'Total Number of Invitations',
  New88_2:' / Person',
  New89:'Commission Rebate Ratio',
  New90:'Reward Redemption',
  New91:'Redeemed',
  New92:'Redeem Data/GB',
  New93:'Redeem',
  New94:'Invitation Code and Link',
  New95:'Invite Now',
  New96:'Failure',
  New97:'Invitation Link',
  New98:'Event Rules',
  New99:'CDKEY',
  New100: 'Remaining Data',
  New101: 'Remaining Corporate Data',
  New200: 'Resource pool needs to be switched, please contact customer service',
  New102:'There is no CDKEY available for copying.',
  New103:'Tutorial Document',
  New104:'Product FAQ',
  New105:'Please enter a valid number.',
  New106:'The redemption amount cannot be less than 10GB.',
  New107:'The redemption amount must be a multiple of 10.',
  New108:'Please enter the redemption amount.',
  // 12.25后新增
  New109:'Purchase Details',
  New110:'Balance Details',
  New111:'Exchange Record',
  New112:'individual',
  New113:'Cdkey Usage Record',
  New114:'Please select the exchange type',
   New115:'plan traffic',
    New116:'Pending Payment',
    New117:'(The exchange amount cannot exceed the reward balance)',
    New118:'Insufficient reward balance',
  
  New120:'Renew',
  New121:'Buy',
  New122:'User Account',
  New123:'Recharge Status',
  New124:'Please enter your name',
  New125:'Please enter your surname',
  New126:'Please enter your country',
  New127:'The length should be between 8-15 digits',
  New128:'The length should be between 8-20 digits',
  New129:'Must contain numbers, letters, and special characters',
  New130:'',
  New131:'Please select the complete time',
  New132:'Unused redemption code',
  New133:'Please try again later',
  New134:'Gear One: Low Gear',
  New135:'Gear Two: Medium gear',
  New136:'Gear Three: High Gear',
  New137:'Important Precautions',
  New138:'Advertising Restrictions',
  New139:'Penalty For Violation',
  New140:'Commission',
  New141:'Example',
  New142:'Refund Policy',
  New143:'Prohibit bidding for Thordata trademark in paid search advertisements',
  New144:'Accounts that violate the rules will be suspended',
  New145:'User cancellation of subscription or refund will result in the cancellation of corresponding commission',
  New146:'Commission Calculation Rules',
  New147:'Rule Execution Process',
  New148:'Invited Users Complete Payment',
  New149:'The system automatically detects the amount',
  New150:'Calculate And Distribute Commission',
  New151:'Refund Or Unsubscribe',
  New152:'Advertising Restrictions',
  New153:'The user must successfully complete the subscription payment in order to trigger commission calculation. Payment failure or cancellation of orders will not be counted towards commission.',
  New154:'The system detects the actual amount redeemed by users in real time and automatically matches the corresponding commission rate level based on the size of the amount.',
  New155:'Calculate the amount according to the determined commission rate, using the formula: commission=user payment amount x commission rate.',
  New156:'The commission will be automatically paid to your account during the settlement period.',
  New157:'It is strictly prohibited to bid for Thordata trademark and related keywords in paid search advertisements.',
  New158:'Violators will face account suspension and commissions already generated will not be paid.',
  New159:'Data retrieval successful',
  New160:'Data retrieval failed',
  New161:'The amount paid by UnionPay shall not exceed 4340 US dollars',

  customization:'Customization',
  regular:'Regular',
  detection: 'Proxy detection',
  copyLink: 'Copy Link',
  openLink: 'Open Link',
  dashboard42: 'No news for now.',
  ip5_2: '1 rotation port, 60 sticky ports',
  ip16_1: 'Generated Quantity',
  ip16_2: 'Sticky duration',
  ip16_3: 'Sticky duration (5-180 minutes)',
  global_random: 'Global Random',
  whitestatus: 'Whitelist Status',
  remainderTime: 'Remainder Time',
  plan41_2: 'Export successful',
  plan41_3: 'Export failed',
  plan48: 'Export quantity',
  orderTip1: 'Please contact service before ordering',
  referralProgram53_1: 'Cycle Type',
  referralProgram88_1: 'Week',
  panel5text12: 'View',
  panel5text12_4: 'Details',
  panel5text12_5: 'API Extract',
  panel5text12_6: 'Bandwidth statistics',
  Africa: 'Africa',
  Program108: 'Total requests',
  Program109: 'successful requests',
  Program110: 'Consume flow(G)',
  New166:'Resource pool switching, please contact service',
  staticProduct:'Static Product',
  ISPDetail:'ISP Detail',
  IPV4Detail:'IPV4 Detail',
  IPV6Detail:'IPV6 Detail',
  buyIP:'Purchase IP',
  static_dash_la3: "Extract IP",
  static_qymx_la2: "Extract IP Number",
  dashboard_static1: 'Total',
  dashboard_static2: 'Used',
  dashboard_static3: 'Remaining',
  dashboard_static4: 'utilization rate',
  tabTitleUnit: 'piece',
  static_xf_lang1: "Renewal Type",
  static_xf_lang1_1: "Please select renewal type",
  static_xf_lang1_2: "Renewal of remaining IPs",
  static_xf_lang1_3: "Wallet Renewal",
  static_xf_lang2: "Renewal cycle",
  static_xf_lang2_1: "Please select the renewal period",
  static_xf_lang3: "Renewal Amount",
  static_xf_lang4: "months",
  static_xz_lang15: "Failed to obtain the period list.",
  static_xz_lang16: "Failed to obtain period data.",
  static_xz_lang20: "Select a country/region.",
  static_xz_lang21: "Please select a period.",
  static_xz_lang22: "Select an agreement.",
  static_xz_lang27:'Select a scene',
  static_xz_lang28:'Scene',
  static_xz_lang29: "country/region",
  static_xz_lang30: "Please select a continent",
  continent: 'continent',
  static_dash_la2: "Please select or enter the quantity",
  static_dash_la5: 'Operation too frequent, please try again later',
  static_yc_lang1: "You can only add up to 20",
  noValidDataSelected:'Please select valid data for renewal',
  someDataFiltered:'Automatically filtered',
  invalidData:'Invalid data record',
  static_info_lan1: 'Purchase',
  static_info_lan2: 'Extraction',
  static_info_lan3: 'Top Up',
  static_info_lan4: 'Renewal',
  ipStatus_5: 'Normal',
  ipStatus_6: 'Refunded',
  Batch: 'batch',
  static_ip_lang: "Static IP",
  static_port_lang: "Socks5 port",
  static_port_lang2: "HTTP(s) port",
  effectiveDate: 'Effective Date',
  ipStatus_1: 'In Use',
  ipStatus_2: 'Expiring Soon',
  ipStatus_3: 'Expired',
  ipStatus_4: 'Replaced',
  protocolType: 'protocol type',
  noDataSelected: 'Please select the data first',
  inventory1:"inventory",
  inventory3:"The maximum renewal period is 6 months",
  inventory4:"The maximum renewal period is 1 month",
  inventory2:"Insufficient stock to add",
  RegularName:"Regular",
  tuijian: 'Recommend',
  xinpin: 'NEW',
  payTxt: 'Please choose a payment method',
  static_title1: "Generation List",
  static_title2: "Personal operation",
  message: 'Payment has been cancelled',
  message_1: 'Payment processing failed',
  ageNumber1: 'Effective',
  ip7_1: 'Host',
  ip8_1: 'Port',
  sele11: "Infinte Proxy",
  panel1tip4_1: 'National positioning',
  panel1tip4_2: 'Used in 190+ countries',
  panel1tip4_22: 'Used in 230+ countries',
  panel1tip4_23: '100+ Country Options',
  panel1tip4_3: 'sticky session',
  panel1tip4_5: 'Unlimited data',
  panel6text7: 'Infinite Plan',
  panel1tip2_18: 'unlimited data',
  panel1tip2_19: 'unlimited IP',
  panel1tip2_20: 'Real Residential Agent',
  panel1tip2_22: 'Great customization discount',
  panel1tip7: 'Flexible Configuration',
  panel1tip8: 'Dedicated Account Manager',
  panel1tip9: 'Exclusive Custom Solutions',
  payLimitTip: 'This payment method supports a maximum of $10,000. Please return to the price page and select again.',
  bandwidth: 'bandwidth',
  mobileName:'Mobile Product',
  mobileProxy: 'Mobile Proxies',
  supReason1_1: 'Geolocation',
  panel1tip2_12: '5 million+ Mobile Proxies',
  panel1tip33: 'Success rate over 99.99%',
  panel1tip34: '3G/4G/5G/LTE Mobile Proxy Network',
  panel6text5: 'Personal Plan Usage Record',
  activityTitle2: '20% OFF',
  basicPlan: 'Basic',
  connectPlan: 'Custom Plan',
  error: 'Error',
  error_800: 'The maximum value cannot exceed 800.',
  fail: 'Failed',
  Mode: 'Mode',
  noDataToCopy: 'No data to copy',
  num_required5: 'The minimum quantity is 5.',
  Paddleinfo: 'This product is a digital item delivered instantly upon payment and is non-refundable once purchased.',
  PaymentFailed: 'Payment failed',
  PendingPayment: 'Pending payment',
  please: 'Please ',
  ProxyGenerator: 'Proxy Generator',
  static_dash_la4: 'Other',
  static_dash_la6: 'Are you sure to close this dialog?',
  static_dazhou_la1: 'Asia',
  static_dazhou_la2: 'Europe',
  static_dazhou_la3: 'North America',
  static_dazhou_la4: 'South America',
  static_dazhou_la5: 'Oceania',
  static_dazhou_la6: 'Africa',
  static_fz_la1: 'Copy IP',
  static_oper_lang1: 'Renewal',
  static_oper_lang3: 'Copy',
  static_xz_lang11: 'Copy successful',
  static_xz_lang13: 'Failed to obtain the country list.',
  static_xz_lang14: 'Failed to obtain data.',
  static_xz_lang17: 'Please enter the quantity.',
  static_xz_lang2: 'Please select period',
  static_xz_lang5: 'Renewal successful',
  static_xz_lang6: 'Renewal failed',
  static_xz_lang7: 'Please select type',
  static_xz_lang8: 'Please enter remark',
  static_zh_type1: 'Not working',
  static_zh_type2: 'Incorrect location',
  static_zh_type3: 'Cannot switch networks',
  static_zh_type4: 'Slow network',
  static_zh_type5: 'Custom',
  underMaintenance: 'Under maintenance',
  whitestatus0: 'Add request pending',
  whitestatus1: 'Added successfully',
  whitestatus2: 'Failed to add',
  whitestatus3: 'Delete request pending',
  whitestatus4: 'Deleted successfully',
  whitestatus5: 'Deletion failed',
};
export default lang;
